import { useEffect, useState, useRef, useMemo } from "react";
import {
  FilterButton,
  ActionButton,
  AltButton,
} from "../../common/Buttons/Buttons";
import { Header } from "../../common/Header/Header.jsx";
import todos from "../../../images/todos.svg";
import { useForm } from "react-hook-form";
import particulares from "../../../images/particulares.svg";
import afiliados from "../../../images/afiliados.svg";
import { useTranslation } from "react-i18next";
import { IncidenceCards, IncidenceColumn } from "../../common/Cards/Cards";
import { SearchInput, FilterDatePicker } from "../../common/Forms/Input/Input";
import * as schemas from "../../../assets/schemas/schemas";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  FilterCaseButton,
  ActivateButtons,
} from "../../common/Buttons/Buttons";
import { caseService } from "../../../services/caseService";
import { stagesService } from "../../../services/stagesService";
import { paymentService } from "../../../services/paymentService";
import { trackingsService } from "../../../services/trackingsService";
import { membershipService } from "../../../services/membershipService";
import { gpsService } from "../../../services/gpsService";
import { faultsService } from "../../../services/faultsService";
import { contactChannelService } from "../../../services/contactChannelService";
import { productService } from "../../../services/productService";
import authService from "../../../services/authService";
import { servicesService } from "../../../services/servicesService";
import { providersService } from "../../../services/providersService";
import { particularCustomerService } from "../../../services/particularCustomerService";
import { rateService } from "../../../services/rateService";
import { vehicularAssetsService } from "../../../services/vehicularAssetsService";
import { usersService } from "../../../services/usersService";
import useIvaCalculation, { toNumber, round2 } from "../../../hooks/useIvaCalculation";
import useCaseListSocket from "../../../hooks/useCaseListSocket";
import { groupCasesByStatus } from "../../../assets/helpers/caseListReducer";
import { Input } from "../../common/Forms/Input/Input";
import {
  NewIncidenceModal,
  CancelCaseModal,
  FailedCaseModal,
  CancelSingleServiceModal,
  CancelServiceModal,
  UploadImageModal,
  ServiceImageModal,
  LocksmithReimbursementModal,
  LocksmithFinishModal,
  FinishCaseModal,
  SolvedByAVModal,
  FinishTowCaseModal,
  FailureAssignTowModal,
  FollowingModal,
  ChangeCaseStageModal,
  ChangeProviderModal,
  ChangeOperatorModal,
  RegisterFollowUPModal,
  ChangeTowModal,
  TaxiServiceModal,
  MessageAVModal,
  MessageLocksmithModal,
  MessageTowModal,
  MessageTaxiModal,
  CreatePaymentModal,
  EditPaymentModal,
  EditCashbackModal,
  SelectServicePaymentModal,
  SelectCashbackPaymentModal,
  AllDevicesMapModal,
  RollbackStageModal,
  ScheduleServicesModal,
  ScheduleTowModal,
} from "../../common/Modals/Modals";
import { useHistory, useLocation } from "react-router-dom";
import {
  enumStatus,
  afiliatedServices,
  particularServices,
  capitalize,
  PaymentStatusOptions,
  lastServiceEnum,
  PaymentStatus,
  paymentMethods as metodosDePago,
  getProvidersEnum,
  userTypeOptions,
  userType,
  statusEnum,
  incidenceColumnsEnum,
  sumErrorMessage,
  resolveCancelReasonType,
} from "../../../assets/helpers/options";
import {
  filterParams,
  hideForOperators,
  translateStatus,
  translateFullStatus,
  filterOption,
  filterOptionById,
  calculateMiddlePoint,
  isValidMongoId,
  isZelleOrPaypal,
  validateUpdatePaymentRefLenght,
  isLocksmithService,
  buildLocksmithFormData,
  locksmithInvoiceToForm,
} from "../../../assets/helpers/funciones";
import { operationsRoles } from "../../../assets/helpers/roles";
import {
  canFinishPendingLoadCase,
  getLastRoadAssistanceService,
  getLastTowService,
  getLocksmithFinishMode,
  hasTowService,
  locksmithFinishMode,
} from "../../../assets/helpers/caseValidations";
import { notify } from "../../../assets/helpers/toast";
import moment from "moment";
import { CraneCounter } from "../../miscelaneos/CraneCounter/CraneCounter.jsx";
import "./Services.scss";
import { cashReceiverService } from "../../../services/cashReceiverService.js";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner.jsx";

const filterButtons = [
  { name: "Todos", value: "", image: todos },
  { name: "Afiliados", value: "Afiliado", image: afiliados },
  { name: "Particulares", value: "Particular", image: particulares },
];

export const Services = () => {
  const topScrollRef = useRef(null);
  const contentScrollRef = useRef(null);
  const devicesLocationRequestRef = useRef(false);
  const smsModalRequestRef = useRef(false);
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [fileUploaded, setFileUploaded] = useState([]);
  const [optStatus, setOTPStatus] = useState(0);
  const optStatusRef = useRef(0);
  const paymentOtpBaselineRef = useRef({
    price: 0,
    amountHandling: 0,
    amountExcess: 0,
  });
  const validatedPaymentOtpRef = useRef(null);
  const excessRequestRef = useRef(0);

  const updateOtpStatus = (status) => {
    optStatusRef.current = status;
    setOTPStatus(status);
  };
  const [searchCase, setSearchCase] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [cashReceiverOptions, setCashReceiverOptions] = useState([]);

  const [showCraneCounterModal, setShowCraneCounterModal] = useState({
    show: false,
    src: "",
    zoom: 1,
  });

  const {
    register,
    // handleSubmit: handleSubmit,
    formState: { errors },
    // setValue: setValue,
    // reset: reset,
    watch,
    // setError: setError,
    // control: control,
    setValue,
  } = useForm({
    resolver: yupResolver(schemas.CreatePaymentSchema(t)),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
    reset: reset2,
    watch: watch2,
    setError: setError2,
    control: control2,
  } = useForm({
    resolver: yupResolver(schemas.CreatePaymentSchema(t)),
  });

  const {
    register: register3,
    handleSubmit: handleSubmit3,
    formState: { errors: errors3 },
    setValue: setValue3,
    reset: reset3,
    setError: setError3,
    watch: watch3,
    control: control3,
  } = useForm({
    resolver: yupResolver(schemas.createFollowUpSchema(t)),
  });

  const {
    register: register4,
    handleSubmit: handleSubmit4,
    formState: { errors: errors4 },
    watch: watch4,
    control: control4,
  } = useForm({
    resolver: yupResolver(schemas.editCashbackSchema(t)),
  });

  const {
    register: register5,
    handleSubmit: handleSubmit5,
    formState: { errors: errors5 },
    setValue: setValue5,
    watch: watch5,
  } = useForm({
    resolver: yupResolver(schemas.changeTowSchema(t)),
  });
  const {
    register: register6,
    handleSubmit: handleSubmit6,
    formState: { errors: errors6 },
    setValue: setValue6,
    setError: setError6,
    control: control6,
    watch: watch6,
  } = useForm({
    resolver: yupResolver(schemas.editPaymentSchema(t)),
  });

  const {
    register: register7,
    handleSubmit: handleSubmit7,
    formState: { errors: errors7 },
    control: control7,
    reset: reset7,
  } = useForm({
    resolver: yupResolver(schemas.ScheduleServiceSchema(t)),
  });

  const {
    register: register8,
    formState: { errors: errors8 },
    setValue: setValue8,
    watch: watch8,
  } = useForm({
    resolver: yupResolver(schemas.OTPSchema(t)),
  });

  const {
    register: register9,
    handleSubmit: handleSubmit9,
    formState: { errors: errors9 },
    control: control9,
    reset: reset9,
  } = useForm({
    resolver: yupResolver(schemas.ScheduleServiceSchema(t)),
  });

  const {
    register: register10,
    handleSubmit: handleSubmit10,
    formState: { errors: errors10 },
    control: control10,
    reset: reset10,
  } = useForm({
    resolver: yupResolver(schemas.ScheduleTowSchema(t)),
  });


  const setBsRate = (e) => {
    const { name, value } = e?.target;

    // Replocate Accholder in referene only if the method is Zelle or Paypal
    let method = name?.replace("accHolder", "method");
    let reference = name?.replace("accHolder", "reference");

    const selectedMethod = filterOptionById(paymentMethods, watch2(method));
    if (
      [metodosDePago.ZELLE, metodosDePago.PAYPAL].includes(selectedMethod?.name)
    ) {
      setValue2(reference, watch2(name));
    }

    if (name.includes("amount")) {
      setValue2(
        name.replace("amount", "amountBsS"),
        (value * dollarRate).toFixed(2)
      );
    }

    if (/^method\d+$/.test(name)) {
      const slotIndex = name.replace("method", "");
      setValue2(`skipApiValidationError${slotIndex}`, false);
    }
  };

  useEffect(() => {
    const top = topScrollRef.current;
    const content = contentScrollRef.current;
    if (!top || !content) return;

    const inner = top.querySelector('.top-scroll-inner');

    const setTopWidth = () => {
      const width = content.scrollWidth + 'px';
      if (inner && inner.style.width !== width) inner.style.width = width;
    };

    // Ajusta el alto del contenedor al espacio disponible hasta el final de la ventana
    const setContentHeight = () => {
      const offsetTop = content.getBoundingClientRect().top + window.scrollY;
      const available = window.innerHeight - offsetTop - 16;
      const maxHeight = Math.max(available, 300) + 'px';
      if (content.style.maxHeight !== maxHeight) {
        content.style.maxHeight = maxHeight;
      }
    };

    // Se difiere al siguiente frame: escribir estilos de los elementos
    // observados dentro del callback del ResizeObserver dispara
    // "ResizeObserver loop completed with undelivered notifications".
    let frameId = null;
    const onResize = () => {
      if (frameId) return;
      frameId = requestAnimationFrame(() => {
        frameId = null;
        setTopWidth();
        setContentHeight();
      });
    };

    const onTopScroll = () => {
      content.scrollLeft = top.scrollLeft;
    };

    const onContentScroll = () => {
      top.scrollLeft = content.scrollLeft;
    };

    // Initial sync
    onResize();

    // Observe content size changes
    const ro = new ResizeObserver(onResize);
    ro.observe(content);
    ro.observe(document.body);

    top.addEventListener('scroll', onTopScroll);
    content.addEventListener('scroll', onContentScroll);
    window.addEventListener('resize', onResize);

    return () => {
      if (frameId) cancelAnimationFrame(frameId);
      ro.disconnect();
      top.removeEventListener('scroll', onTopScroll);
      content.removeEventListener('scroll', onContentScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const [caseTypeFilter, setCaseTypeFilter] = useState(filterButtons[0].value);
  const [showIncidenceModal, setShowIncidenceModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showErrorAPI, setShowErrorAPI] = useState(false);
  const [faultOptions, setFaultOptions] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [contactChannelOptions, setContactChannelOptions] = useState([]);
  const [providersOptions, setProvidersOptions] = useState([]);
  const [towOptions, setTowOptions] = useState([]);
  const [externalTowOptions, setExternalTowOptions] = useState([]);
  const [operatorsOptions, setOperatorsOptions] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [selectedTow, setSelectedTow] = useState("");
  const [otpTow, setOtpTop] = useState("");
  const [towType, setTowType] = useState(userType?.INTERNO);
  const [caseStatus, setCaseStatus] = useState("");
  const [dollarRate, setDollarRate] = useState("");
  const [devicesLocation, setDevicesLocation] = useState({
    isLoading: false,
    data: [],
  });
  const [paymentStatusOptions, setPaymentStatusOptions] =
    useState(PaymentStatusOptions);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [filteredMethods, setFilteredMethods] = useState([]);
  const [errorsDropzone, setErrorsDropzone] = useState({});
  const [cashBackImage, setCashBackImage] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [paymentDate, setPaymentDate] = useState("");
  const [vehicleDocuments, setVehicleDocuments] = useState({
    propertyTitle: "",
    rcv: "",
  });
  const [sinceDate, setSinceDate] = useState(
    // new Date(Date.now() - 3600 * 1000 * 24)
    ""
  );
  const [untilDate, setUntilDate] = useState(
    // new Date(Date.now() + 3600 * 1000 * 24)
    ""
  );
  const [showChangeStatusModal, setShowChangeStatusModal] = useState({
    isOpen: false,
    selected: "",
  });
  const [showImageModal, setShowImageModal] = useState({
    isOpen: false,
    label: "Servicio AV",
    message: "(PNG, JPG, JEPG, máx. 3MB)",
    selected: "",
    incidence: undefined,
  });
  const [showFollowingModal, setShowFollowingModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [showServiceImageModal, setShowServieImageModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [showReembolsoModal, setShowReembolsoModal] = useState({
    isOpen: false,
    selected: "",
  });
  const [locksmithFinishModal, setLocksmithFinishModal] = useState({
    isOpen: false,
    selected: null,
    mode: null,
  });
  const [showFinishCaseModal, setShowFinishCaseModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [showSolvedByAVModal, setShowSolvedByAVModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [showFinishTowCaseModal, setFinishTowCaseModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [showFailureAssignModal, setShowFailureAssignModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [showChangeOperatorModal, setShowChangeOperatorModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [showFollowUpModal, setShowFollowUpModal] = useState({
    isOpen: false,
    selected: "",
  });
  const [changeProviderModal, setChangeProviderModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [paymentModal, setPaymentModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [editPaymentModal, setEditPaymentModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [cashbackModal, setCashbackModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });
  const [selectServicePayment, setSelectServicePayment] = useState({
    isOpen: false,
    services: "",
  });
  const [selectCashbackPayment, setSelectCashbackPayment] = useState({
    isOpen: false,
    cashbacks: "",
  });

  const [changeTowModal, setChangeTowModal] = useState({
    isOpen: false,
    selected: "",
    uploaded: "",
  });

  const [taxiServiceModal, setTaxiServiceModal] = useState({
    isOpen: false,
    selected: "",
  });

  const [taxiOtpCooldown, setTaxiOtpCooldown] = useState(0);

  useEffect(() => {
    if (taxiOtpCooldown <= 0) return;
    const timer = setInterval(() => {
      setTaxiOtpCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [taxiOtpCooldown]);

  const [showSMSTowModal, setShowSMSTowModal] = useState({
    isOpen: false,
    provider: "",
    _case: "",
  });

  const [showSMSModal, setShowSMSModal] = useState({
    isOpen: false,
    provider: "",
    _case: "",
  });
  const [showTaxiSMSModal, setShowTaxiSMSModal] = useState({
    isOpen: false,
    provider: "",
    _case: "",
  });
  const [showCancelCase, setShowCancelCase] = useState({
    show: false,
    caseSelected: "",
    cancelOptions: [],
  });
  const [showRollbackStage, setShowRollbackStage] = useState({
    show: false,
    caseSelected: "",
    cancelOptions: [],
  });
  const [showScheduleRescheduleModal, setShowScheduleRescheduleModal] =
    useState({
      show: false,
      selected: null,
    });
  const [showToggleScheduleModal, setShowToggleScheduleModal] = useState({
    show: false,
    selected: null,
  });
  const [showScheduleTowModal, setShowScheduleTowModal] = useState({
    show: false,
    selected: null,
  });
  const [showFailedCase, setFailedCancelCase] = useState({
    show: false,
    caseSelected: "",
    cancelOptions: [],
  });
  const [showCancelService, setShowCancelService] = useState({
    show: false,
    caseSelected: "",
    cancelOptions: [],
  });
  const [showCancelSingleService, setShowCancelSingleService] = useState({
    show: false,
    selected: "",
    cancelOptions: [],
  });
  // Lista plana de casos: la alimentan el GET y el socket de actualización de casos
  const [caseList, setCaseList] = useState([]);
  const cases = useMemo(() => groupCasesByStatus(caseList), [caseList]);
  //* todos los casos en un solo arreglo para la vista mobile de operadores
  const casesByOperator = hideForOperators() ? [] : caseList;
  const subscribeCases = useCaseListSocket(setCaseList);
  const selectButton = (value) => {
    setCaseTypeFilter(value);
  };

  const handleCancelCase = (incidence) => {
    if (incidence) {
      membershipService
        .getCancelReason(resolveCancelReasonType(incidence))
        .then((response) => {
          if (response.status === 200) {
            setShowCancelCase({
              cancelOptions: response?.data?.newCancellationReasons,
              show: !showCancelCase.show,
              selected: incidence ? incidence : "",
            });
          } else {
            notify(`${response.message}` || "error", "error");
          }
        })
        .catch(() => { });
    } else {
      setShowCancelCase({
        cancelOptions: [],
        show: !showCancelCase.show,
        selected: incidence ? incidence : "",
      });
    }
  };

  const validateIfUseRequest = () => {
    return [
      operationsRoles?.OPERATIONS_FLOTA_AV,
      operationsRoles?.OPERATIONS_FLOTA_GRUA,
      operationsRoles?.OPERATIONS_FLOTA_GRUA_EXT,
    ]?.includes(authService.getUserType());
  };

  const handleRollbackCase = (incidence) => {
    setShowRollbackStage({
      show: !showRollbackStage.show,
      selected: incidence ? incidence : "",
    });
  };

  const closeScheduleRescheduleModal = (refresh) => {
    setShowScheduleRescheduleModal({ show: false, selected: null });
    reset7();
    if (refresh) getCasesByOperator();
  };

  const handleEditScheduledServiceModal = (incidence) => {
    if (!incidence?.lastService?._id) {
      notify("No se encontró el servicio agendado", "error");
      return;
    }
    setShowScheduleRescheduleModal({
      show: true,
      selected: incidence,
    });
    if (incidence?.scheduleDate) {
      const sd = moment(incidence.scheduleDate);
      if (sd.isValid()) {
        reset7({
          date: sd.toDate(),
          time: sd.format("HH:mm"),
        });
      } else {
        reset7();
      }
    } else {
      reset7();
    }
  };

  const rescheduleScheduledService = handleSubmit7(async (data) => {
    const incidence = showScheduleRescheduleModal?.selected;
    const serviceId = incidence?.lastService?._id;
    if (!serviceId) return;
    let fecha = moment(data?.date).format("YYYY-MM-DD");
    let date = new Date(fecha + "T" + data?.time);
    date = moment(date).format();
    if (!isLoading) {
      setIsLoading(true);
      servicesService
        .rescheduleService({ date }, serviceId)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify("Servicio reagendado con éxito", "success");
            closeScheduleRescheduleModal(true);

          } else {
            notify(response?.message || "Error al reagendar", "error");
          }
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
  });

  const closeToggleScheduleModal = (refresh) => {
    setShowToggleScheduleModal({ show: false, selected: null });
    reset9();
    if (refresh) getCasesByOperator();
  };

  const handleToggleToScheduledModal = (incidence) => {
    if (!incidence?.lastService?._id) {
      notify("No se encontró el servicio de grúa", "error");
      return;
    }
    reset9();
    setShowToggleScheduleModal({ show: true, selected: incidence });
  };

  const submitToggleToScheduled = handleSubmit9(async (data) => {
    const incidence = showToggleScheduleModal?.selected;
    const serviceId = incidence?.lastService?._id;
    if (!serviceId) return;
    let fecha = moment(data?.date).format("YYYY-MM-DD");
    let date = new Date(fecha + "T" + data?.time);
    date = moment(date).format();
    if (!isLoading) {
      setIsLoading(true);
      servicesService
        .rescheduleTow({ date }, serviceId)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify("Servicio cambiado a agendado con éxito", "success");
            closeToggleScheduleModal(true);
          } else {
            notify(
              response?.message || "Error al cambiar a servicio agendado",
              "error"
            );
          }
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
  });

  const handleUnscheduleTow = (incidence) => {
    const serviceId = incidence?.lastService?._id;
    if (!serviceId) {
      notify("No se encontró el servicio de grúa", "error");
      return;
    }
    if (!isLoading) {
      setIsLoading(true);
      servicesService
        .unschedule(serviceId)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify("Servicio cambiado a normal con éxito", "success");
            getCasesByOperator();
          } else {
            notify(
              response?.message || "Error al cambiar a servicio normal",
              "error"
            );
          }
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
  };

  const closeScheduleTowModal = (refresh) => {
    setShowScheduleTowModal({ show: false, selected: null });
    reset10();
    if (refresh) getCasesByOperator();
  };

  const handleScheduleTowModal = (incidence) => {
    reset10();
    setShowScheduleTowModal({ show: true, selected: incidence });
  };

  const submitScheduleTow = handleSubmit10(async (data) => {
    const incidence = showScheduleTowModal?.selected;
    const caseId = incidence?._id;
    if (!caseId) return;
    let fecha = moment(data?.date).format("YYYY-MM-DD");
    let date = new Date(fecha + "T" + data?.time);
    date = moment(date).format();
    if (!isLoading) {
      setIsLoading(true);
      caseService
        .scheduleTow({ date, reason: data?.reason }, caseId)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify("Servicio de grúa agendado con éxito", "success");
            closeScheduleTowModal(true);
          } else {
            notify(
              response?.message || "Error al agendar el servicio de grúa",
              "error"
            );
          }
          setIsLoading(false);
        })
        .catch(() => setIsLoading(false));
    }
  });

  const handleFailedCase = (incidence) => {
    const servicesLength = incidence?.services?.length;
    if (
      incidence?.services[servicesLength - 1]?.type === "Grua" &&
      incidence?.services[servicesLength - 1]?.paymentStatus ===
      PaymentStatus?.N_A &&
      incidence?.services[servicesLength - 1]?.payments?.length === 0
    ) {
      // Pasar un flag para hacer que sea requerido cambiar el estatus de pago
      handlePaymentModal(
        incidence?.services[servicesLength - 1],
        true,
        incidence
      );
    } else {
      setFailedCancelCase({
        show: !showFailedCase.show,
        selected: incidence ? incidence : "",
      });
    }
  };

  const handleCancelSingleService = (service) => {
    setShowCancelSingleService({
      cancelOptions: showCancelService?.cancelOptions
        ? showCancelService?.cancelOptions
        : [],
      show: !showCancelSingleService.show,
      service: service ? service?._id : "",
    });

    setShowCancelService({
      cancelOptions: [],
      show: false,
      services: "",
    });
  };

  const handleCancelService = (incidence) => {
    if (incidence) {
      membershipService
        .getCancelReason(resolveCancelReasonType(incidence))
        .then((response) => {
          if (response.status === 200) {
            setShowCancelService({
              cancelOptions: response?.data?.newCancellationReasons,
              show: !showCancelCase.show,
              services: incidence ? incidence?.services : "",
            });
          } else {
            notify(`${response.message}` || "error", "error");
          }
        })
        .catch(() => { });
    } else {
      setShowCancelService({
        cancelOptions: [],
        show: !showCancelService.show,
        services: incidence ? incidence?.services : "",
      });
    }
  };

  const getFaults = () => {
    sessionStorage.removeItem("status");
    sessionStorage.removeItem("sinceDate");
    sessionStorage.removeItem("untilDate");
    let params = {
      limit: 1000,
      isActive: true,
    };

    faultsService
      .getFaults(params)
      .then((response) => {
        if (response.status === 200) {
          setFaultOptions(response?.data?.newFaults);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getContactChannel = () => {
    if (validateIfUseRequest()) {
      return;
    }

    contactChannelService
      .getContactChannels()
      .then((response) => {
        if (response.status === 200) {
          setContactChannelOptions(response?.data);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const showCase = (incidence) => {
    history.push(`/incidence/detail/${incidence?._id}`);
  };
  const editCase = (incidence) => {
    history.push(`/incidence/edit/${incidence?._id}`);
  };

  const handleLoadImageModal = (incidence) => {
    if (incidence) {
      const serviceId = getLastRoadAssistanceService(incidence)?._id;

      if (serviceId) {
        getUploadedTowImages(serviceId);
      }

      setShowImageModal((prevState) => ({
        ...prevState,
        isOpen: true,
        selected: serviceId || "",
        incidence,
      }));
      return;
    }

    setShowImageModal((prevState) => ({
      ...prevState,
      isOpen: false,
      selected: "",
      incidence: undefined,
    }));
  };

  const handleFinishCaseModal = (incidence, thirdParty) => {

    if (
      incidence?.status === enumStatus.PENDING_LOAD &&
      !canFinishPendingLoadCase(incidence, authService?.getUserType())
    ) {
      notify(
        "Debe cargar las imágenes y registrar los pagos pendientes antes de finalizar el caso",
        "error"
      );
      return null;
    }

    setShowFinishCaseModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showFinishCaseModal?.isOpen,
        selected: incidence ? incidence : "",
        thirdParty: thirdParty ? thirdParty : "",
      };
    });
  };

  const handleSolvedByAVModal = (incidence) => {
    setShowSolvedByAVModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showSolvedByAVModal?.isOpen,
        selected: incidence ? incidence : "",
      };
    });
  };

  const handleFinishTowCaseModal = (incidence) => {
    if (
      incidence?.status === enumStatus.PENDING_LOAD &&
      !canFinishPendingLoadCase(incidence, authService?.getUserType())
    ) {
      notify(
        "Debe cargar las imágenes y registrar los pagos pendientes antes de finalizar el caso",
        "error"
      );
      return null;
    }

    let seguimiento = "";
    if (incidence) {
      [seguimiento] = incidence?.services?.filter(
        (s) => s?.type === "Seguimiento"
      );
    }

    // Update validation with role
    //! por si se cambia de parecer validacion de imagen
    // if (incidence && !seguimiento) {
    //   let [services] = incidence?.services?.filter(
    //     (s) => s?.type === "Grua" && s?.status !== "Cancelado"
    //   );
    //   if (
    //     ![operationsRoles?.operationsAdmin, operationsRoles?.operationsSupervisor,].includes(authService?.getUserType()) &&
    //     services &&
    //     (!services?.towImages?.towAtOrigin ||
    //       !services?.towImages?.vehicleOnRoad ||
    //       !services?.towImages?.vehicleOnTow)
    //   ) {
    //     notify("Falta subir imagenes de la grua", "error");
    //     return null;
    //   }
    // }

    if (
      incidence &&
      !hasTowService(incidence) &&
      (incidence.services[0]?.type === "Asistencia vial" || seguimiento) &&
      incidence?.status !== enumStatus.PENDING_LOAD
    ) {
      let dataToPost = {
        solvedByAV: false,
        stage: incidence?.lastStage?._id,
      };

      caseService
        .finishCase(dataToPost, incidence?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Caso Finalizado con éxito`, "success");
            getCasesByOperator();
          } else {
            notify(`${response.message}`, "error");
          }
        })
        .catch((error) => { });

      return null;
    }

    setFinishTowCaseModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showFinishTowCaseModal?.isOpen,
        selected: incidence ? incidence : "",
      };
    });
  };

  const handleFailureAssignModal = (incidence) => {
    setShowFailureAssignModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showFailureAssignModal?.isOpen,
        selected: incidence ? incidence : "",
      };
    });
  };

  const handleChangeOperatorModal = (incidence) => {
    setShowChangeOperatorModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showChangeOperatorModal?.isOpen,
        selected: incidence ? incidence : "",
      };
    });
  };

  const handleFollowUpModal = (incidence) => {
    reset3();
    setShowFollowUpModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showFollowUpModal?.isOpen,
        selected: incidence ? incidence : "",
      };
    });

    if (incidence) {
      let { tripTracking } = incidence?.services[0];

      // After opening the followup modal then preload the dates and enable the fields
      for (let i = 0; i < tripTracking?.trackings?.length; i++) {
        setValue3(
          `plannedDate${i}`,
          moment(tripTracking?.trackings[i]?.scheduled)?.format("DD/MM/YYYY LT")
        );
        if (!tripTracking?.trackings[i]?.user) {
          setValue3(`when${i}`, new Date());
          setValue3(`time${i}`, moment(new Date())?.format("HH:mm"));
        } else {
          setValue3(`edited${i}`, true);
          setValue3(`when${i}`, new Date(tripTracking?.trackings[i]?.when));
          setValue3(
            `time${i}`,
            moment(tripTracking?.trackings[i]?.when)?.format("HH:mm")
          );
          setValue3(`user${i}`, tripTracking?.trackings[i]?.user);
          setValue3(`channel${i}`, tripTracking?.trackings[i]?.channel);
          setValue3(`note${i}`, tripTracking?.trackings[i]?.note);
        }
      }
    }
  };

  const registerFollowUp = handleSubmit3(async (data, index) => {
    const validateInput = (name) => {
      if (!data[`${name}${index}`]) {
        setError3(`${name}${index}`, {
          type: "custom",
          message: "Obligatorio",
        });
      } else return true;
    };

    if (!validateInput(`channel`) || !validateInput(`user`)) {
      return null;
    }

    let service = showFollowUpModal?.selected?.services[0];

    let dataToSend = {
      id: service?.tripTracking?.trackings[index]?._id,
      channel: data[`channel${index}`],
      note: data[`note${index}`],
      user: data[`user${index}`],
      when: data[`when${index}`],
    };

    if (!isLoading) {
      setIsLoading(true);
      trackingsService
        .changeSolved({ trackings: [dataToSend] }, service?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Seguimiento registrado`, "success");
            getCasesByOperator();
            setValue3(`edited${index}`, true);
            setIsLoading(false);
          } else {
            notify(`${response.message} `, "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const handleSolveCase = (incidence) => {
    if (incidence) {
      setIsLoading(true);
      caseService
        .changeSolved(incidence?._id, !incidence?.solvedByAV)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Caso actualizado`, "success");
            getCasesByOperator();
          } else {
            notify(`${response.message}`, "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const handleSelectedProviderModal = (incidence) => {
    setSelectedProvider(incidence?._id);
  };

  const handleChangeProviderModal = (incidence) => {
    setSelectedProvider("");
    if (incidence) {
      getAVs();
    }
    setChangeProviderModal((prevState) => {
      return {
        ...prevState,
        isOpen: !changeProviderModal?.isOpen,
        selected: incidence ? incidence : "",
      };
    });
  };

  const handleExpressCheck = (incidence) => {
    history?.push(`/incidence/express-check/${incidence?._id}`);
  };

  const handleSelectService = (incidence) => {
    if (incidence && incidence?.services?.length === 1) {
      handlePaymentModal(incidence?.services[0], "", incidence);
    } else {
      setSelectServicePayment((prevState) => {
        return {
          ...prevState,
          isOpen: !selectServicePayment?.isOpen,
          services: incidence?.services ? incidence?.services : [],
          incidence: incidence,
        };
      });
    }
  };

  const handleUpdateCashback = (incidence) => {
    let cashbacks = [];
    for (let i = 0; i < incidence?.services?.length; i++) {
      if (incidence?.services[i]?.paymentChanges?.length > 0) {
        for (
          let j = 0;
          j < incidence?.services[i]?.paymentChanges?.length;
          j++
        ) {
          cashbacks?.push(incidence?.services[i]?.paymentChanges[j]);
        }
      }
    }

    setSelectCashbackPayment((prevState) => {
      return {
        ...prevState,
        isOpen: !selectCashbackPayment?.isOpen,
        cashbacks: cashbacks?.length > 0 ? cashbacks : [],
      };
    });
  };

  const handleCashbackModal = (payment, denyN_A, incidence) => {
    setCashbackModal((prevState) => {
      return {
        ...prevState,
        isOpen: !cashbackModal?.isOpen,
        selected: payment ? payment : "",
        denyN_A: denyN_A,
        incidence: incidence,
      };
    });

    if (payment) {
      setValue3("method", payment?.method?._id);
      setValue3("amount", payment?.amount);
      setValue3("amountBs", payment?.amountBs);
      setValue3("date", new Date(payment?.date));
      setValue3("ref", payment?.ref);
    } else {
      reset3();
    }
  };

  const editCashback = handleSubmit4(async (data) => {
    let dataToPost = { ...data };

    const formData = new FormData();
    formData.append("method", dataToPost?.method);
    formData.append("amount", dataToPost?.amount);
    formData.append("amountBs", dataToPost?.amountBs);
    formData.append("date", dataToPost?.date);
    formData.append("ref", dataToPost?.ref);
    if (cashBackImage?.image0) {
      formData.append("paymentEvidence", cashBackImage?.image0);
    }

    setIsLoading(true);
    paymentService
      .editCashback(formData, cashbackModal?.selected?._id)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Vuelto actualizado`, "success");
          handleCashbackModal();
          handleUpdateCashback();
          getCasesByOperator();
          removeFile();
          setTimeout(() => {
            window?.location?.reload();
          }, 1500);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  });

  const handlePaymentModal = (service, denyN_A, incidence) => {
    if (
      [
        afiliatedServices?.tire,
        afiliatedServices?.battery,
        afiliatedServices?.accompaniment,
      ].includes(service?.product?.code) ||
      isLocksmithService(service)
    ) {
      setPaymentStatusOptions([
        { name: PaymentStatus?.N_A, _id: PaymentStatus?.N_A },
      ]);
    } else {
      setPaymentStatusOptions(PaymentStatusOptions);
    }

    excessRequestRef.current += 1;
    validatedPaymentOtpRef.current = null;
    updateOtpStatus(0);
    setValue2("code", "");
    setValue2("approvedBy", "");
    setPaymentModal((prevState) => {
      return {
        ...prevState,
        isOpen: !paymentModal?.isOpen,
        selected: service ? service : "",
        denyN_A: denyN_A,
        incidence: incidence,
      };
    });

    if (service) {
      setValue2("serviceName", capitalize(service?.product?.name));
      setValue2("paymentMethods", 0);
      setValue2("price", service?.price);
      setValue2("pvp", service?.pvp);
      setValue2("paymentStatus", service?.paymentStatus);
      setValue2("amountExcess", service?.amountExcess || 0);
      setValue2("amountHandling", service?.amountHandling || 0);
      paymentOtpBaselineRef.current = {
        price: toNumber(service?.price),
        amountHandling: toNumber(service?.amountHandling),
        amountExcess: toNumber(service?.amountExcess),
      };
      setValue2("paymentDifference", 0);
      if (service?.pendingPayment?.datePaid) {
        setValue2("paid", true);
      }

      setValue2(
        "accumulatedAmount",
        calulateAcumulatedAmount(service?.payments)
      );

      const paymentWithIva = service?.payments?.find((p) => p?.ivaAmount);
      if (paymentWithIva) {
        setValue2("addIva", true);
        setValue2("ivaAmount", paymentWithIva.ivaAmount);
        setValue2("ivaPercentage", paymentWithIva.ivaPercentage);
      }

      const isLocksmith = isLocksmithService(service);
      setValue2("isLocksmith", isLocksmith);
      if (isLocksmith) {
        setValue2("paymentStatus", PaymentStatus?.N_A);
        setValue2("price", service?.price > 0 ? service?.price : "");
        setValue2("locksmithInvoice", undefined);
        Object.entries(locksmithInvoiceToForm(service?.locksmithInvoice)).forEach(
          ([field, value]) => setValue2(field, value)
        );
      }
    } else {
      reset2();
    }
  };

  const calulateAcumulatedAmount = (payments) => {
    let monto = 0;

    for (let i = 0; i < payments.length; i++) {
      monto = monto + payments[i]?.totalAmount;
    }
    return monto;
  };

  const changePaymentStatus = () => {
    switch (watch2("paymentStatus")) {
      case PaymentStatus?.DE_CONTADO:
        let paymentDifference =
          parseFloat(watch2("pvp")) - watch2("accumulatedAmount");
        setValue2(
          "accumulatedAmount",
          calulateAcumulatedAmount(paymentModal?.selected?.payments)
        );
        setValue2("pvp", paymentModal?.selected?.pvp);
        setValue2("paymentDifference", paymentDifference);
        setValue2("amount0", paymentDifference);
        setValue2("amountBsS0", paymentDifference * dollarRate);
        break;
      case PaymentStatus?.CUENTA_POR_COBRAR:
        setValue2("pvp", paymentModal?.selected?.pvp);
        setValue2("paymentDifference", 0);
        break;
      case PaymentStatus?.N_A:
        setValue2("pvp", 0);
        setValue2("paymentDifference", 0);
        break;

      default:
        break;
    }
  };

  const restorePaymentMethods = () => {
    const paymentDifference =
      toNumber(watch2("pvp")) +
      toNumber(watch2("amountHandling")) +
      toNumber(watch2("amountExcess")) -
      toNumber(watch2("accumulatedAmount"));
    const ivaAmount = toNumber(watch2("ivaAmount"));

    if (paymentDifference >= 0) {
      const totalToCharge = round2(paymentDifference + ivaAmount);
      setValue2("paymentDifference", totalToCharge);
      setValue2("amount0", totalToCharge);
      setValue2("amountBsS0", (totalToCharge * dollarRate)?.toFixed(2));
    }
  };

  const requestTowOTP = () => {
    let towService = getLastTowService(changeTowModal?.selected);
    if (!towService) {
      notify("El caso no tiene un servicio de grúa para actualizar", "error");
      return;
    }

    if (!isLoading) {
      setIsLoading(true);
      servicesService
        .requestOTP(towService?._id, {
          provider: selectedTow,
          price: toNumber(towService.price),
          amountExcess: toNumber(towService.amountExcess),
          amountHandling: toNumber(towService.amountHandling),
        })
        .then((response) => {
          if (response.status === 200) {
            notify("Codigo generado con exito y enviado a su correo", "info");
            setIsLoading(false);
          } else {
            notify(`${response.message}` || "error", "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const validateTowOTP = () => {
    let towService = getLastTowService(changeTowModal?.selected);
    if (!towService) {
      notify("El caso no tiene un servicio de grúa para actualizar", "error");
      return;
    }

    const data = {
      code: watch5("code"),
      price: toNumber(towService.price),
      amountExcess: toNumber(towService.amountExcess),
      amountHandling: toNumber(towService.amountHandling),
    };

    if (!isLoading) {
      setIsLoading(true);
      servicesService
        .validateOTP(towService?._id, data)
        .then((response) => {
          if (response.status === 200) {
            notify("Codigo validado con exito ", "info");
            setIsLoading(false);
            setValue5("validCode", true);
          } else {
            notify(`${response.message}` || "error", "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const handleTowType = (e) => {
    // const { value } = e?.target;
    // setTowType(value);
    setSelectedTow("");
  };

  const handleTow = (e) => {
    const { value } = e;
    setSelectedTow(value);
  };

  const handleChangeTowModal = (incidence) => {
    setSelectedTow("");
    setValue5("towType", false);
    setValue5("externalTowReason", "");
    setValue5("approvedBy", false);
    setValue5("code", "");
    setValue5("validCode", false);
    if (incidence) {
      getInternalTows();
      getExternalTows();
    }
    setChangeTowModal((prevState) => {
      return {
        ...prevState,
        isOpen: !changeTowModal?.isOpen,
        selected: incidence ? incidence : "",
      };
    });
  };

  const handleTaxiServiceModal = (incidence) => {
    setValue8("code", "");
    setTaxiServiceModal((prevState) => ({
      ...prevState,
      isOpen: !taxiServiceModal?.isOpen,
      selected: incidence ? incidence : "",
    }));
  };

  const requestTaxiOtp = (serviceId) => {
    if (!isLoading) {
      setIsLoading(true);
      setTaxiOtpCooldown(60);
      servicesService.getTaxiOtp(serviceId).then((response) => {
        if (response.status === 200) {
          notify("Codigo OTP solicitado", "success");
          setIsLoading(false);
        } else {
          notify(response?.message || "Error al solicitar codigo", "error");
          setTaxiOtpCooldown(0);
          setIsLoading(false);
        }
      }).catch(() => {
        notify("Error al solicitar codigo", "error");
        setTaxiOtpCooldown(0);
        setIsLoading(false);
      });
    }
  };

  const validateTaxiCode = () => {
    const serviceId = taxiServiceModal?.selected?.lastService?._id;
    const code = watch8("code");
    const selectedCase = taxiServiceModal?.selected;
    if (!serviceId || !code) return;
    servicesService
      .validateTaxiOtp(serviceId, { code })
      .then((response) => {
        if (response.status === 200) {
          notify("Codigo validado con exito", "success");
          handleTaxiServiceModal();
          getCasesByOperator()
            .then((refreshResponse) => {
              const updatedCase =
                refreshResponse?.data?.cases?.find(
                  (c) => c._id === selectedCase?._id
                ) || selectedCase;
              openTaxiSMSModal(updatedCase);
            })
            .catch(() => openTaxiSMSModal(selectedCase));
        } else {
          notify(response?.message || "Error al validar", "error");
        }
      })
      .catch(() => {
        notify("Error al validar codigo", "error");
      });
  };

  const handleFollowingCaseModal = (incidence) => {
    setShowFollowingModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showFollowingModal?.isOpen,
        selected: incidence ? incidence : "",
      };
    });
  };

  const handleChangeStatusModal = (incidence, nextStatus) => {
    setShowChangeStatusModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showChangeStatusModal?.isOpen,
        nextStatus: incidence ? nextStatus : "",
        selected: incidence ? incidence : "",
      };
    });
  };

  let loadPaymentForms = (params) => {
    let payments = [];
    // lOOP through every payment method

    if (
      (watch2("paymentMethods") && watch2("paymentDifference") > 0) ||
      [PaymentStatus?.CUENTA_POR_COBRAR]?.includes(watch2("paymentStatus"))
    ) {
      for (let i = 0; i < parseInt(watch2("paymentMethods")); i++) {
        let payment = {
          method: params[`method` + i.toString()],
          reference: params[`reference` + i.toString()],
          amount: params[`amount` + i.toString()],
          amountBsS: params[`amountBsS` + i.toString()],
        };

        if (
          [
            metodosDePago?.CASH_USD,
            metodosDePago?.CASH_BS,
            metodosDePago?.CASH_EUR,
          ].includes(
            filterOptionById(paymentMethods, watch2(`method${i}`)).name
          )
        ) {
          payment.cashReceiver = params[`cashReceiver` + i.toString()];
        }
        if (params[`accHolder` + i.toString()]) {
          payment.accHolder = params[`accHolder` + i.toString()];
        }
        payments.push(payment);
      }

      // "REmove unwanted params from JSON"
      let words = [
        "method",
        "reference",
        "amount",
        "amountBsS",
        "paymentMethod",
      ];
      for (const key in params) {
        for (var i = 0, ln = words.length; i < ln; i++) {
          if (key.indexOf(words[i]) !== -1) {
            delete params[key];
          }
        }
      }
      params.payments = payments;
    }

    return params;
  };

  const appendFile = (data) => {
    const formData = new FormData();
    formData.append("service", data?.service);
    formData.append("paymentStatus", data?.paymentStatus);

    if (
      watch2("paymentStatus") === PaymentStatus?.CUENTA_POR_COBRAR &&
      data?.paymentDate
    ) {
      formData.append("paymentDate", moment(data?.paymentDate).toISOString());
    }
    formData.append("price", data?.price);
    formData.append("pvp", data?.pvp);
    if (watch2("amountHandling")) {
      formData.append("amountHandling", watch2("amountHandling"));
    }
    if (watch2("authorizedBy")) {
      formData.append("authorizedBy", watch2("authorizedBy"));
    }
    if (watch2("amountExcess")) {
      formData.append("amountExcess", watch2("amountExcess"));
    }
    if (watch2("code")) {
      formData.append("code", watch2("code"));
    }
    if (watch2("approvedBy")) {
      formData.append("approvedBy", watch2("approvedBy"));
    }

    let totalPayment = 0;
    if (watch2("paymentMethods") == 0) {
      return formData;
    }

    // Load payment methods and amounts if payment status is not N_A  or CUENTA_POR_COBRAR
    if (
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch2("paymentStatus")
      ) ||
      ([PaymentStatus?.CUENTA_POR_COBRAR]?.includes(watch2("paymentStatus")) &&
        data?.payments[0].amount)
    ) {
      for (var i = 0; i < data?.payments?.length; i++) {
        formData.append(`payments[${i}][amount]`, data?.payments[i].amount);
        formData.append(
          `payments[${i}][amountBsS]`,
          data?.payments[i].amountBsS
        );
        formData.append(`payments[${i}][method]`, data?.payments[i].method);
        formData.append(
          `payments[${i}][reference]`,
          data?.payments[i].reference
        );

        if (data?.payments[i].accHolder) {
          formData.append(
            `payments[${i}][accHolder]`,
            data?.payments[i].accHolder
          );
        }

        if (data?.payments[i].cashReceiver) {
          formData.append(
            `payments[${i}][cashReceiver]`,
            data?.payments[i].cashReceiver
          );
        }

        if (data?.addIva) {
          formData.append(`payments[${i}][ivaAmount]`, data?.ivaAmount);
          formData.append(
            `payments[${i}][ivaPercentage]`,
            data?.ivaPercentage
          );
        }

        if (showErrorAPI && watch2(`skipApiValidationError${i}`)) {
          formData.append(
            `payments[${i}][skipApiValidationError]`,
            watch2(`skipApiValidationError${i}`)
          );
        }
        totalPayment = totalPayment + parseFloat(data?.payments[i].amount);
      }
      for (let i = 0; i < parseInt(watch2("paymentMethods")); i++) {
        if (fileUploaded[i]) {
          formData.append(`paymentEvidence`, fileUploaded[i]);
        }
      }
    }
    // Load as many files as payment methods we have
    if (
      fileUploaded.length !== parseFloat(watch2("paymentMethods")) &&
      parseFloat(watch2("paymentMethods")) > 0 &&
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch2("paymentStatus")
      )
    ) {
      notify("Ingrese comprobantes de pago", "info");
      return null;
    }

    let totalSum =
      parseFloat(watch2("pvp")) +
      parseFloat(watch2("amountHandling")) +
      parseFloat(watch2("amountExcess")) +
      parseFloat(watch2("ivaAmount") || 0);

    for (let j = 0; j < parseFloat(watch2("cashbackMethodsQuantity")); j++) {
      formData.append(`paymentChanges[${j}][paid]`, data[`paid`]);
      formData.append(
        `paymentChanges[${j}][method]`,
        data[`returnedMethod${j + 1}`]
      );
      formData.append(
        `paymentChanges[${j}][amount]`,
        data[`returnedAmount${j + 1}`]
      );
      formData.append(
        `paymentChanges[${j}][amountBsS]`,
        data[`returnedAmountBsS${j + 1}`]
      );
      if (data[`returnedReference${j + 1}`]) {
        formData.append(
          `paymentChanges[${j}][ref]`,
          data[`returnedReference${j + 1}`]
        );
      }
      formData.append(
        `paymentChanges[${j}][hasEvidence]`,
        data[`returnedReference${j + 1}`] ? true : false
      );
      if (cashBackImage[`image${j + 1}`]) {
        formData.append(
          `paymentChangeEvidence`,
          cashBackImage[`image${j + 1}`]
        );
      }
    }

    // Para realizar pagos de Cuentas por cobrar
    if (
      watch2("paymentStatus") === PaymentStatus?.CUENTA_POR_COBRAR &&
      watch2("paymentMethods") >= 1 &&
      !watch2("paid")
    ) {
      if (totalSum && totalSum !== totalPayment) {
        notify(sumErrorMessage, "info");
        return null;
      }
      return formData;
    }

    // Para realizar ajustes en cuentas por cobrar
    if (
      watch2("paymentStatus") === PaymentStatus?.CUENTA_POR_COBRAR &&
      watch2("paymentMethods") >= 1 &&
      watch2("paid")
    ) {
      if (
        watch2("paymentDifference") &&
        watch2("paymentDifference") !== totalPayment
      ) {
        notify(sumErrorMessage + '2', "info");
        return null;
      }
      return formData;
    }

    // Para realizar pagos
    if (
      watch2("paymentDifference") &&
      watch2("paymentDifference") !== totalPayment &&
      watch2("paymentStatus") !== PaymentStatus?.CUENTA_POR_COBRAR
    ) {
      notify(sumErrorMessage + '3', "info");
      return false;
    }

    return formData;
  };

  const activateProvider = () => {
    let user = authService?.getUser();

    let dataToPost = {
      isActive: !user?.provider?.isActive,
      vehicle: isValidMongoId(watch("vehicle")) ? watch("vehicle") : "",
    };

    providersService
      .acrtivateProvider(filterParams(dataToPost), user?.provider._id)
      .then((response) => {
        if (response.status === 200) {
          notify(
            `Usuario ${!user?.provider?.isActive ? "activado" : "desactivado"
            } `,
            "success"
          );
          user.provider.isActive = !user.provider.isActive;

          if (!user?.provider?.isActive) {
            sessionStorage.removeItem("assignedVehicle");
            sessionStorage.clear();
            history.push("/login");
          } else {
            let vehicle = filterOptionById(vehicleList, watch("vehicle"));
            sessionStorage.setItem(`assignedVehicle`, JSON.stringify(vehicle));
          }

          setTimeout(() => {
            sessionStorage.setItem(`user`, JSON.stringify(user));
            // window?.location?.reload();
            getFaults();
            getCasesByOperator();
            getAvailableVehicles();
          }, 2000);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      });
  };

  const closePaymentModalAfterSave = () => {
    reset2();
    if (paymentModal?.incidence) {
      getCasesByOperator();
      setSelectServicePayment((prevState) => {
        return {
          ...prevState,
          isOpen: false,
        };
      });
      setPaymentModal((prevState) => {
        return {
          ...prevState,
          isOpen: false,
          selected: "",
          denyN_A: false,
          incidence: "",
        };
      });
      setIsLoading(false);
    } else {
      setTimeout(() => {
        window?.location.reload();
        setIsLoading(false);
      }, 2000);
    }
  };

  // Cerrajeria: Actualizar Pago solo guarda costo y factura del cliente
  const updateLocksmithPayment = (data) => {
    if (isLoading) return;
    setIsLoading(true);
    servicesService
      .updateLocksmith(buildLocksmithFormData(data), paymentModal?.selected?._id)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          notify(`Pago actualizado`, "success");
          closePaymentModalAfterSave();
        } else {
          notify(
            `${response?.data?.message || response?.message || "No pudimos actualizar el servicio de cerrajería"}`,
            "error"
          );
          setIsLoading(false);
        }
      })
      .catch(() => setIsLoading(false));
  };

  const createPayment = handleSubmit2(async (data) => {
    if (isLocksmithService(paymentModal?.selected)) {
      updateLocksmithPayment(data);
      return;
    }

    if (optStatusRef.current === 1) {
      notify("Debe validar el codigo OTP para procesar el pago", "info");
      return null;
    }

    let isCash =
      watch2("method0") ===
      filterOption(paymentMethods, metodosDePago?.CASH_USD)?._id;

    if (!validateTotalPayment(data)) {
      return null;
    }

    if (isCash) {
      calculateCashBack();

      if (parseFloat(watch2("cashbackMethodsQuantity")) > 0) {
        // Validate the total of the cashback
        // Validate that all images are up
        if (!validateCashBackTotal() || !validateCashBackImages()) {
          return null;
        }
      }
    }

    let dataToPost = { ...data };

    dataToPost = loadPaymentForms(dataToPost);
    dataToPost.service = paymentModal?.selected?._id;

    if (
      watch2("paymentStatus") === PaymentStatus?.COURTESY &&
      !watch2("authorizedBy")
    ) {
      setError2("authorizedBy", { type: "custom", message: "Obligatorio" });
      return null;
    }

    let fileToPost = appendFile(dataToPost);

    if (data?.paymentStatus === PaymentStatus?.N_A && paymentModal?.denyN_A) {
      notify("Debe modificar el estatus de pago", "info");
      return null;
    }

    if (!isLoading && fileToPost) {
      setIsLoading(true);
      paymentService
        .createPayment(fileToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Pago actualizado`, "success");
            if (paymentModal?.incidence) {
              getCasesByOperator();
              setSelectServicePayment((prevState) => {
                return {
                  ...prevState,
                  isOpen: false,
                };
              });
              setPaymentModal((prevState) => {
                return {
                  ...prevState,
                  isOpen: false,
                  selected: "",
                  denyN_A: false,
                  incidence: "",
                };
              });
              setIsLoading(false);
            } else {
              setTimeout(() => {
                window?.location.reload();
                setIsLoading(false);
              }, 2000);
            }
          } else {
            setShowErrorAPI(true);
            notify(
              `${response?.data?.message || response?.message || "No pudimos validar el pago, por favor revisa los datos ingresados"}`,
              "error"
            );
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setShowErrorAPI(true);
          setIsLoading(false);
        });
    }
  });

  const updateProvider = () => {
    let data = {
      provider: selectedProvider,
      caseId: changeProviderModal?.selected?._id,
    };

    //return the last service id to update the provider wich type is AV
    let lastServiceId = changeProviderModal?.selected?.services?.filter(
      (s) => s?.type === "Asistencia vial"
    )[0]?._id;

    if (!isLoading) {
      setIsLoading(true);
      servicesService
        .updateProvider(data, lastServiceId)
        .then((response) => {
          if (response.status === 200) {
            notify(`Motorizado actualizado con exito`, "success");
            handleChangeProviderModal();
            getCasesByOperator();
            setIsLoading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsLoading(false);
          }
        })
        .catch(() => { });
    }
  };

  const createTowService = (_case) => {
    if (_case?.status === enumStatus?.AV_IN_ORIGIN) {
      let dataToPost = {
        case: _case?._id,
        useExtendedTow: _case?.membership?.hasExtendedTow,
      };

      if (!isLoading) {
        setIsLoading(true);
        servicesService
          .createTowService(dataToPost)
          .then((response) => {
            if ([200, 201].includes(response.status)) {
              setIsLoading(false);

              // Force Destiny address
              if (
                !_case?.destinyState?.name ||
                !_case?.originCity?.name ||
                !_case?.destinyAddress
              ) {
                notify(
                  "Por favor agrege una dirección de destino al caso para poder asignarle una grua",
                  "info"
                );
                getCasesByOperator();
                setIsLoading(false);
                return null;
              }

              if (
                [
                  operationsRoles.OPERATIONS_FLOTA_AV,
                  operationsRoles.OPERATIONS_FLOTA_GRUA,
                  operationsRoles.OPERATIONS_FLOTA_GRUA_EXT,
                ].includes(authService.getUserType())
              ) {
                getCasesByOperator();
              } else {
                history.push(
                  `/incidence/assign-provider/${_case?._id}/service/${response?.data?.serviceId}`
                );
              }
            } else {
              notify(`${response.message}`, "error");
              setIsLoading(false);
            }
          })
          .catch(() => {
            notify("No se pudo crear el servicio de grúa", "error");
            setIsLoading(false);
          });
      }
    } else {
      const towService = getLastTowService(_case);
      if (!towService) {
        notify("El caso no tiene un servicio de grúa para asignar", "error");
        return;
      }
      history.push(
        `/incidence/assign-provider/${_case?._id}/service/${towService?._id}`
      );
    }
  };

  const updateTow = handleSubmit5(async (data) => {
    const towService = getLastTowService(changeTowModal?.selected);
    if (!towService) {
      notify("El caso no tiene un servicio de grúa para actualizar", "error");
      return;
    }

    let dataToPost = {
      provider: selectedTow,
      caseId: changeTowModal?.selected?._id,
      code: data?.code,
      approvedBy: data?.approvedBy,
      externalTowReason: data?.externalTowReason,
    };

    if (!isLoading) {
      setIsLoading(true);
      servicesService
        .updateProvider(filterParams(dataToPost), towService?._id)
        .then((response) => {
          if (response.status === 200) {
            notify(`Gruero actualizado con exito`, "success");
            handleChangeTowModal();
            getCasesByOperator();
            setIsLoading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsLoading(false);
          }
        })
        .catch(() => {
          notify("No se pudo actualizar el gruero", "error");
          setIsLoading(false);
        });
    }
  });

  const selectStatusFilter = (status) => {
    let today = new Date();
    let weekFromNow = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);
    switch (status) {
      case enumStatus?.FINISHED:
        // let weekAgo = new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000);
        // setSinceDate(weekAgo);
        setSinceDate(today);
        setUntilDate(today);
        sessionStorage.setItem(`sinceDate`, today);
        sessionStorage.setItem(`untilDate`, today);
        break;
      case enumStatus?.SCHEDULED:
        setSinceDate(today);
        setUntilDate(weekFromNow);
        sessionStorage.setItem(`sinceDate`, today);
        sessionStorage.setItem(`untilDate`, weekFromNow);
        break;
      case enumStatus?.PENDING_PAYMENT:
        setSinceDate(today);
        setUntilDate(weekFromNow);
        sessionStorage.setItem(`sinceDate`, today);
        sessionStorage.setItem(`untilDate`, weekFromNow);
        break;
      default:
        setSinceDate("");
        setUntilDate("");
        sessionStorage.removeItem("sinceDate");
        sessionStorage.removeItem("untilDate");
        break;
    }

    sessionStorage.setItem(`status`, status);

    setCaseStatus(status);
  };

  const updateCaseStage = () => {
    if (!isLoading) {
      setIsLoading(true);
      caseService
        .updateCaseStage(
          { stage: showChangeStatusModal?.selected?.lastStage?._id },
          showChangeStatusModal?.selected?._id
        )
        .then((response) => {
          if (response.status === 200) {
            notify(
              `Tarjeta desplazada a ${response?.data?.description}`,
              "success"
            );
            handleChangeStatusModal();
            getCasesByOperator();
            setIsLoading(false);
          } else {
            notify(`${response.message}`, "error");
            isLoading(false);
          }
        })
        .catch((error) => console.error("error", error));
    }
  };

  const getAVs = () => {
    let params = {
      limit: 100000,
      offset: 0,
      isInternal: true,
      isActive: true,
      type: getProvidersEnum?.ROAD_ATTENDANT,
    };
    providersService
      .getProvidersByType(params)
      .then((response) => {
        if (response.status === 200) {
          let data = [...response?.data?.providers];

          for (let i = 0; i < data?.length; i++) {
            data[i].label =
              capitalize(data[i]?.contactName) +
              " (" +
              translateFullStatus(data[i]) +
              ") ";
            data[i].value = data[i]?._id;
          }

          // translateStatus

          setProvidersOptions(data);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };
  const getInternalTows = () => {
    let params = {
      limit: 100000,
      offset: 0,
      isInternal: true,
      type: getProvidersEnum?.CRANE,
    };
    providersService
      .getProvidersByType(params)
      .then((response) => {
        if (response.status === 200) {
          let data = response?.data?.providers;

          for (let i = 0; i < data?.length; i++) {
            const isActive = data[i]?.isActive === "Activo";
            data[i].label =
              capitalize(data[i]?.contactName) +
              " (" +
              (isActive ? translateStatus(data[i]?.status) : "Inactivo") +
              ") ";
            data[i].value = data[i]?._id;
            data[i].isActive = isActive;
          }

          setTowOptions([{ label: "", value: "" }, ...data]);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const validateMaxPaymentMethods = () => {
    if (parseFloat(watch2("paymentMethods")) > 2) {
      notify("Solo se permiten 2 formas de pago", "info");
      setValue2("paymentMethods", 2);
    }
  };

  const getExternalTows = () => {
    let params = {
      type: getProvidersEnum?.CRANE,
      offset: 0,
      limit: 100000,
      isInternal: false,
    };

    providersService
      .getProvidersByType(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          let data = [];
          for (let i = 0; i < response?.data?.providers?.length; i++) {
            const isActive =
              response?.data?.providers[i]?.isActive === "Activo";
            data.push({
              contactName: response?.data?.providers[i]?.contactName,
              status: "Available",
              _id: response?.data?.providers[i]?._id,
              isActive: isActive,
              label:
                capitalize(response?.data?.providers[i]?.contactName) +
                " (" +
                (isActive ? "Disponible" : "Inactivo") +
                ") ",
              value: response?.data?.providers[i]?._id,
            });
          }

          setExternalTowOptions([{ label: "", value: "" }, ...data]);
        } else {
          notify(`${response.message} `, "error");
        }
      })
      .catch(() => { });
  };

  const getInternalTowServices = () => {
    let params = {
      type: "all",
    };

    providersService
      .getInternalTowServices(params)
      .then((response) => {
        if (response.status === 200) {
          setShowCraneCounterModal((prevState) => {
            return {
              ...prevState,
              data: response?.data,
            };
          });
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const openDocumentModal = (src, service) => {
    const willOpen = !showCraneCounterModal?.show;
    if (willOpen && service) {
      getInternalTowServices();
    }

    setShowCraneCounterModal((prevState) => {
      return {
        ...prevState,
        show: !prevState?.show,
        src: !prevState?.src ? src : "",
        service: service,
      };
    });
  };

  const zoomDocumentModal = (zoom) => {
    setShowCraneCounterModal((prevState) => {
      return {
        ...prevState,
        zoom: zoom,
      };
    });
  };

  const getUsers = () => {
    if (validateIfUseRequest()) {
      return;
    }

    let params = {
      role: operationsRoles?.operationsOperator,
      limit: 1000000,
      offset: 0,
      module: "Operaciones",
    };
    usersService
      .getUsers(params)
      .then((response) => {
        if (response.status === 200) {
          let data = [];
          for (let i = 0; i < response?.data?.users?.length; i++) {
            data.push({
              name:
                response?.data?.users[i]?.firstName +
                " " +
                response?.data?.users[i]?.lastName,
              _id: response?.data?.users[i]?._id,
            });
          }

          setOperatorsOptions(data);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const openSMSTowModal = (_case) => {
    setShowSMSTowModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showSMSTowModal?.isOpen,
        provider: _case?.lastService?.provider,
        _case: _case ? _case : "",
      };
    });
  };

  const openSMSModal = (_case) => {
    setShowSMSModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showSMSModal?.isOpen,
        provider: _case?.lastService?.provider,
        _case: _case ? _case : "",
      };
    });
  };

  const openTaxiSMSModal = (_case) => {
    setShowTaxiSMSModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showTaxiSMSModal?.isOpen,
        provider: _case?.lastService?.provider,
        _case: _case ? _case : "",
      };
    });
  };

  // Parche temporal: el socket pisa el caso del tablero sin dirección/teléfono.
  // Pedimos el detalle solo para el modal; el kanban no se toca. Si el GET falla, igual se abre.
  const handleSMSModal = (_case) => {
    if (!_case?._id || smsModalRequestRef.current) return;

    const openMessagesForCase = (detail) => {
      const productCode = _case?.lastService?.product?.code;
      const isTow = [
        afiliatedServices.crane,
        afiliatedServices.craneExtended,
        particularServices.crane,
        undefined,
      ].includes(productCode);

      const modalCase = {
        ..._case,
        ...(detail || {}),
        membership: _case.membership || detail?.membership,
        particularCustomer: _case.particularCustomer || detail?.particularCustomer,
        vehicleData: _case.vehicleData || detail?.vehicleData,
        lastService: detail?.lastService || _case.lastService,
        fault: _case.fault || detail?.fault,
        user: _case.user || detail?.user,
        originCity: detail?.originCity || _case.originCity,
        originState: detail?.originState || _case.originState,
      };
      const provider =
        modalCase?.lastService?.provider || _case?.lastService?.provider;

      if (isTow) {
        setShowSMSTowModal({
          isOpen: true,
          provider,
          _case: modalCase,
        });
      } else {
        setShowSMSModal({
          isOpen: true,
          provider,
          _case: modalCase,
        });
      }
    };

    smsModalRequestRef.current = true;
    caseService
      .getCaseById(_case._id)
      .then((response) => {
        const payload = response?.data;
        const fullCase =
          response?.status === 200
            ? payload?.case || (payload?._id ? payload : null)
            : null;

        if (fullCase) {
          openMessagesForCase(fullCase);
          return;
        }

        if (response?.status !== 200) {
          notify(
            `${response?.message || "No pudimos consultar el caso"}`,
            "error"
          );
        }
        openMessagesForCase(_case);
      })
      .catch(() => {
        notify("No pudimos consultar el caso", "error");
        openMessagesForCase(_case);
      })
      .finally(() => {
        smsModalRequestRef.current = false;
      });
  };

  const getUploadedTowImages = (serviceId) => {
    servicesService
      .getUploadedImages(serviceId)
      .then((response) => {
        if (response.status === 200) {

          if (response?.data?.towImages) {
            setShowServieImageModal((prevState) => {
              return {
                ...prevState,
                uploaded: response?.data?.towImages,
              };
            });
          }

          if (response?.data?.avImage || response?.data?.avImageSolved) {
            setShowImageModal((prevState) => {
              return {
                ...prevState,
                uploaded: {
                  avImage: response?.data?.avImage,
                  avImageSolved: response?.data?.avImageSolved,
                },
              };
            });
          }
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getDollarRate = () => {
    if (validateIfUseRequest()) {
      return;
    }
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
  };

  const updateAmountBsWithRate = (rate) => {
    setDollarRate(rate);

    const paymentMethodsCount = parseInt(watch2("paymentMethods")) || 0;
    for (let i = 0; i < paymentMethodsCount; i++) {
      const amount = parseFloat(watch2(`amount${i}`));
      if (!isNaN(amount)) {
        setValue2(`amountBsS${i}`, (amount * rate).toFixed(2));
      }
    }

    const cashbackMethodsQuantity =
      parseInt(watch2("cashbackMethodsQuantity")) || 0;
    for (let i = 1; i <= cashbackMethodsQuantity; i++) {
      const amount = parseFloat(watch2(`returnedAmount${i}`));
      if (!isNaN(amount)) {
        setValue2(`returnedAmountBsS${i}`, (amount * rate).toFixed(2));
      }
    }

    const paid = parseFloat(watch2("paid"));
    if (!isNaN(paid)) {
      setValue2("paidBsS", (paid * rate).toFixed(2));
    }

    const amountReturned = parseFloat(watch2("amountReturned"));
    if (!isNaN(amountReturned)) {
      setValue2("amountReturnedBsS", (amountReturned * rate).toFixed(2));
    }
  };

  const getDollarRateByPaymentDate = (date) => {
    if (!date) {
      return;
    }

    const params = {
      currency: "USD",
      date: moment(date).format("YYYY-MM-DD"),
      limit: 1,
    };

    rateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          const rate = response?.data?.result[0]?.rate;
          if (rate) {
            updateAmountBsWithRate(rate);
          }
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
  };

  const getDollarRateByDate = (e) => {
    setPaymentDate(e);

    const params = {
      currency: "USD",
      date: e ? moment(e).format("YYYY-MM-DD") : "",
      limit: 1,
    };

    rateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          let rate = response?.data?.result[0]?.rate;
          setValue6(
            "amountBsS",
            (rate * parseFloat(watch6("amount"))).toFixed(2)
          );
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
  };

  const getPaymentMethods = () => {
    if (validateIfUseRequest()) {
      return;
    }

    productService
      .getPaymentMethods("operations")
      .then((response) => {
        if (response.status === 200) {
          setPaymentMethods(response?.data);
          setFilteredMethods(
            // response?.data
            response?.data?.filter((d) => d?.name !== metodosDePago?.CASH_USD)
          );
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const handleServiceImageModal = (incidence) => {
    // servicesService
    if (incidence?.lastService?._id) {
      getUploadedTowImages(incidence?.lastService?._id);
    }

    setShowServieImageModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showServiceImageModal?.isOpen,
        selected: incidence ? incidence?.lastService?._id : "",
      };
    });
  };

  const handleReembolsoModal = (incidence) => {
    setShowReembolsoModal((prevState) => {
      return {
        ...prevState,
        isOpen: !prevState?.isOpen,
        selected: incidence || "",
      };
    });
  };

  const closeLocksmithFinishModal = () => {
    setLocksmithFinishModal({ isOpen: false, selected: null, mode: null });
  };

  const finalizeLocksmithCase = (fullCase) => {
    if (isLoading || !fullCase?._id) return;
    setIsLoading(true);
    caseService
      .finalizeLocksmith(fullCase._id)
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          notify("Caso finalizado con éxito", "success");
          getCasesByOperator();
        } else {
          notify(
            `${response?.message || "No pudimos actualizar el caso de cerrajería"}`,
            "error"
          );
        }
      })
      .catch(() => {
        notify("No pudimos actualizar el caso de cerrajería", "error");
      })
      .finally(() => setIsLoading(false));
  };

  // Sin factura: modal de cancelar. Con factura y reembolso: finaliza sin modal.
  const handleFinishLocksmith = (incidence) => {
    if (!incidence?._id) {
      closeLocksmithFinishModal();
      return;
    }

    caseService.getCaseById(incidence._id).then((response) => {
      const fullCase = response?.status === 200 ? response?.data?.case : null;
      if (!fullCase) {
        notify(
          `${response?.message || "No pudimos consultar el caso de cerrajería"}`,
          "error"
        );
        return;
      }

      const mode = getLocksmithFinishMode(fullCase);
      if (mode === locksmithFinishMode.FINISH) {
        finalizeLocksmithCase(fullCase);
        return;
      }

      setLocksmithFinishModal({
        isOpen: true,
        selected: fullCase,
        mode,
      });
    });
  };

  // Create particular customer
  const createParticularCustomer = (incidence) => {
    let data = {
      firstName: incidence?.thirdPartyParticularCustomerName,
      lastName: incidence?.thirdPartyParticularCustomerLastName,
      phonePrefix: incidence?.thirdPartyServicePhonePrefix,
      phoneNumber: incidence?.thirdPartyServicePhoneNumber,
      vehicleBrand: incidence?.thirdPartyVehicleBrand?._id,
      vehicleModel: incidence?.thirdPartyVehicleModel?._id,
      vehicleYear: incidence?.thirdPartyVehicleYear?.toString(),
      vehicleColor: incidence?.thirdPartyVehicleColor,
      vehiclePlate: incidence?.thirdPartyVehiclePlate,
    };

    if (!isLoading) {
      setIsLoading(true);
      particularCustomerService
        .createParticularCustomer(data)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            createParticularCase(response?.data?.particularCustomer, incidence);
          } else {
            notify(`${response.message}`, "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const createParticularCase = (customer, incidence) => {
    let data = {
      particularCustomer: customer?._id,
      originLocationStatus: incidence?.originLocationStatus,
      originState: incidence?.originState?._id,
      originCity: incidence?.originCity?._id,
      originAddress: incidence?.originAddress,

      contactNumberPrefix: customer?.phonePrefix,
      contactNumber: customer?.phoneNumber,
      destinyLocationStatus: incidence?.destinyLocationStatus,
      destinyState: incidence?.destinyState?._id,
      destinyCity: incidence?.destinyCity?._id,
      destinyAddress: incidence?.destinyAddress,
      caseKm: incidence?.caseKm,
      estimatedTime: incidence?.estimatedTime,
      customerFailureReason: incidence?.fault?._id,
    };

    caseService
      .createCase(filterParams(data))
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          createThirdPartyTowService(response?.data?.case, incidence);
        } else {
          notify(`${response.message}`, "error");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const createThirdPartyTowService = (_case, incidence) => {
    stagesService
      .createInitialTowStage({ case: _case?._id })
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          notify(`Servicio a terceros creado`, "success");
          handleFinishCaseModal(incidence, true);
          setIsLoading(false);
        } else {
          notify(`${response.message}`, "error");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const getMembership = (incidence) => {
    setIsLoading(true);
    particularCustomerService
      .getCasesByOperator(incidence?.thirdPartyVehiclePlate)
      .then((response) => {
        if (response.status === 200) {
          let [customer] = response?.data?.particularCustomers;
          // Find the particular customer or create one
          if (customer) {
            createParticularCase(customer, incidence);
          } else {
            createParticularCustomer(incidence);
          }
          setIsLoading(false);
        } else {
          notify(`${response.message}`, "error");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleThirdPartyTow = (incidence) => {
    // 1 Find particular customer
    // 2 Create particular customer
    // 3 Create particular case
    // 4 Assgin tow service
    // 5 Finish previous case
    getMembership(incidence);
  };

  const asignCrane = (incidence) => {
    // Third party service
    if (
      incidence?.thirdPartyService ||
      incidence?.thirdPartyParticularCustomerName
    ) {
      handleThirdPartyTow(incidence);
      return null;
    }

    if (
      incidence?.services[0]?.type === lastServiceEnum?.ROAD_ATTENDANT &&
      incidence?.status === enumStatus?.AV_IN_ORIGIN
    ) {
      handleFailureAssignModal(incidence);
      return null;
    }

    if (
      incidence?.destinyState?.name &&
      incidence?.originCity?.name &&
      incidence?.destinyAddress
    ) {
      createTowService(incidence);
    } else {
      notify(
        "Por favor agrege una dirección de destino al caso para poder asignarle una grua",
        "info"
      );
      history.push(`/incidence/edit/${incidence?._id}`);
    }
  };
  let options = [
    {
      name: statusEnum?.VER_CASO,
      action: showCase,
      status: Object.values(enumStatus),
    },
    {
      name: statusEnum?.ACTUALIZAR_PAGO,
      action: handleSelectService,
      status: [
        enumStatus.INITIATED,
        enumStatus.AV_ASSIGNED,
        enumStatus.AV_ON_ROAD,
        enumStatus.AV_IN_ORIGIN,
        enumStatus.SEARCHING_TOW,
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.SCHEDULED,
        enumStatus.FINISHED,
        enumStatus.FAILED,
        enumStatus.PENDING_LOAD,
        enumStatus.CANCELED,
        enumStatus.LOCKSMITH_ACTIVE,
      ],
    },
    {
      name: statusEnum?.ACTUALIZAR_VUELTOS,
      action: handleUpdateCashback,
      status: Object.values(enumStatus),
    },
    {
      name: statusEnum?.CAMBIAR_OPERADOR,
      action: handleChangeOperatorModal,
      status: [
        enumStatus.INITIATED,
        enumStatus.AV_ASSIGNED,
        enumStatus.AV_ON_ROAD,
        enumStatus.AV_IN_ORIGIN,
        enumStatus.SEARCHING_TOW,
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.SCHEDULED,
        enumStatus.FOLLOW_UP,
      ],
    },
    {
      name: statusEnum?.CHANGE_TO_SOLVED,
      action: handleSolveCase,
      status: [enumStatus.FINISHED],
    },
    {
      name: statusEnum?.CHANGE_TO_CHECKING,
      action: handleSolveCase,
      status: [enumStatus.FINISHED],
    },
    {
      name: statusEnum?.ASIGNAR_GRUA,
      action: asignCrane,
      status: [enumStatus.AV_IN_ORIGIN],
    },
    {
      name: statusEnum?.CAMBIAR_MOTORIZADO,
      action: handleChangeProviderModal,
      status: [
        enumStatus.AV_ASSIGNED,
        enumStatus.AV_ON_ROAD,
        enumStatus.AV_IN_ORIGIN,
        enumStatus.SCHEDULED,
        enumStatus.FINISHED,
      ],
    },
    {
      name: statusEnum?.REVISION_EXPRESS,
      action: handleExpressCheck,
      status: [enumStatus.AV_ASSIGNED, enumStatus.AV_ON_ROAD],
    },
    {
      name: statusEnum?.CAMBIAR_GRUERO,
      action: handleChangeTowModal,
      status: [
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.SCHEDULED,
        enumStatus.FINISHED,
      ],
    },
    {
      name: statusEnum?.SERVICIO_DE_TAXI,
      action: handleTaxiServiceModal,
      status: [
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.SCHEDULED,
      ],
    },
    {
      name: statusEnum?.REGISTRAR_SEGUIMIENTO,
      action: handleFollowingCaseModal,
      status: [
        enumStatus.INITIATED,
        enumStatus.AV_ASSIGNED,
        enumStatus.AV_ON_ROAD,
        enumStatus.AV_IN_ORIGIN,
        enumStatus.SEARCHING_TOW,
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.SCHEDULED,
      ],
    },
    {
      name: statusEnum?.CARGAR_REEMBOLSO,
      action: handleReembolsoModal,
      status: [enumStatus.LOCKSMITH_ACTIVE],
    },
    {
      name: statusEnum?.CARGAR_IMAGEN,
      action: handleLoadImageModal,
      status: [enumStatus.AV_IN_ORIGIN, enumStatus.PENDING_LOAD],
    },
    {
      name: statusEnum?.CARGAR_IMAGEN_SERVICIO_GRUA,
      action: handleServiceImageModal,
      status: [
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.PENDING_LOAD,
      ],
    },
    {
      name: statusEnum?.EDITAR,
      action: editCase,
      status: [
        enumStatus.AV_ASSIGNED,
        enumStatus.AV_ON_ROAD,
        enumStatus.AV_IN_ORIGIN,
        enumStatus.SEARCHING_TOW,
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.SCHEDULED,
        enumStatus.PENDING_LOAD,
      ],
    },
    {
      name: statusEnum?.CANCELAR_SERVICIO,
      action: handleCancelService,
      status: [
        enumStatus.INITIATED,
        enumStatus.AV_ASSIGNED,
        enumStatus.AV_ON_ROAD,
        enumStatus.AV_IN_ORIGIN,
        enumStatus.SEARCHING_TOW,
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.SCHEDULED,
        enumStatus.PENDING_LOAD,
      ],
    },
    {
      name: statusEnum?.DEVOLVER_CASO,
      action: handleRollbackCase,
      status: [
        // enumStatus.AV_ASSIGNED,
        enumStatus.FINISHED,
      ],
    },
    {
      name: statusEnum?.EDITAR_SERVICIO_AGENDADO,
      action: handleEditScheduledServiceModal,
      status: [
        // enumStatus.AV_ASSIGNED,
        enumStatus.SCHEDULED,
        enumStatus.AV_ASSIGNED,
        enumStatus.TOW_ASSIGNED,

      ],
    },
    {
      name: statusEnum?.CAMBIAR_A_SERVICIO_AGENDADO,
      action: handleToggleToScheduledModal,
      status: [enumStatus.SEARCHING_TOW, enumStatus.TOW_ASSIGNED],
    },
    {
      name: statusEnum?.CAMBIAR_A_SERVICIO_NORMAL,
      action: handleUnscheduleTow,
      status: [enumStatus.SCHEDULED],
    },
    {
      name: statusEnum?.AGENDAR_SERVICIO_GRUA,
      action: handleScheduleTowModal,
      status: [enumStatus.AV_IN_ORIGIN],
    },

    {
      name: statusEnum?.CANCELAR_CASO,
      action: handleCancelCase,
      status: [
        enumStatus.INITIATED,
        enumStatus.AV_ASSIGNED,
        enumStatus.AV_ON_ROAD,
        enumStatus.AV_IN_ORIGIN,
        enumStatus.SEARCHING_TOW,
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.SCHEDULED,
        enumStatus.FOLLOW_UP,
        enumStatus.PENDING_LOAD,
      ],
    },
    {
      name: statusEnum?.FAILED,
      action: handleFailedCase,
      status: [
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
        enumStatus.SCHEDULED,
      ],
    },
  ];

  let actionButtons = [
    {
      name: "Cancelar Caso",
      action: handleCancelCase,
      status: [enumStatus.INITIATED, enumStatus.SCHEDULED],
    },
    {
      name: "Registrar Seguimiento",
      action: handleFollowingCaseModal,
      status: [
        enumStatus.AV_ASSIGNED,
        enumStatus.AV_ON_ROAD,
        enumStatus.SEARCHING_TOW,
        enumStatus.TOW_ASSIGNED,
        enumStatus.TOW_ON_ROAD,
        enumStatus.TOW_IN_ORIGIN,
        enumStatus.CUSTOMER_ON_ROAD,
      ],
    },
    {
      name: "Registrar Contacto",
      action: handleFollowUpModal,
      status: [enumStatus.FOLLOW_UP],
    },
    {
      name: "Finalizar Caso",
      action: handleFinishCaseModal,
      status: [enumStatus.AV_IN_ORIGIN],
    },
  ];
  let statusButtons = [
    { name: "Editar", action: editCase, status: [enumStatus.INITIATED] },
    {
      name: "Cambiar a AV en vía",
      action: handleChangeStatusModal,
      status: [enumStatus.AV_ASSIGNED],
    },
    {
      name: "Cambiar a AV en origen",
      action: handleChangeStatusModal,
      status: [enumStatus.AV_ON_ROAD],
    },
    {
      name: "Falla extra detect/resuelta",
      action: handleSolvedByAVModal,
      status: [enumStatus.AV_IN_ORIGIN],
    },
    {
      name: "Asignar grúa",
      action: asignCrane,
      status: [enumStatus.SEARCHING_TOW],
    },
    {
      name: "Cambiar a grúa en vía",
      action: handleChangeStatusModal,
      status: [enumStatus.TOW_ASSIGNED],
    },
    {
      name: "Cambiar a grúa en origen",
      action: handleChangeStatusModal,
      status: [enumStatus.TOW_ON_ROAD],
    },
    {
      name: "Cliente vía destino",
      action: handleChangeStatusModal,
      status: [enumStatus.TOW_IN_ORIGIN],
    },
    {
      name: "Finalizar caso",
      action: handleFinishTowCaseModal,
      status: [enumStatus.CUSTOMER_ON_ROAD, enumStatus.FOLLOW_UP, enumStatus.PENDING_LOAD],
    },
    {
      name: "Asignar grúa",
      action: asignCrane,
      status: [enumStatus.SCHEDULED],
    },
    {
      name: "Iniciar Servicio",
      action: handleChangeStatusModal,
      status: [enumStatus.SCHEDULED],
    },
    {
      name: "Finalizar caso",
      action: handleFinishLocksmith,
      status: [enumStatus.LOCKSMITH_ACTIVE],
    },
  ];

  const incidenceColumn = [
    {
      cases: cases?.INITIATED,
      title: incidenceColumnsEnum?.ORDEN_NO_CREADA,
      status: enumStatus.INITIATED,
    },
    {
      cases: cases?.AV_ASSIGNED,
      title: incidenceColumnsEnum?.AV_ASIGNADO,
      status: enumStatus.AV_ASSIGNED,
    },
    {
      cases: cases?.AV_ON_ROAD,
      title: incidenceColumnsEnum?.AV_EN_VIA,
      status: enumStatus.AV_ON_ROAD,
    },
    {
      cases: cases?.AV_IN_ORIGIN,
      title: incidenceColumnsEnum?.AV_EN_ORIGEN,
      status: enumStatus.AV_IN_ORIGIN,
    },
    {
      cases: cases?.SEARCHING_TOW,
      title: incidenceColumnsEnum?.EN_BÚSQUEDA_DE_GRÚA,
      status: enumStatus.SEARCHING_TOW,
    },
    {
      cases: cases?.TOW_ASSIGNED,
      title: incidenceColumnsEnum?.GRÚA_ASIGNADA,
      status: enumStatus.TOW_ASSIGNED,
    },
    {
      cases: cases?.TOW_ON_ROAD,
      title: incidenceColumnsEnum?.GRÚA_EN_VÍA,
      status: enumStatus.TOW_ON_ROAD,
    },
    {
      cases: cases?.TOW_IN_ORIGIN,
      title: incidenceColumnsEnum?.GRÚA_EN_ORIGEN,
      status: enumStatus.TOW_IN_ORIGIN,
    },
    {
      cases: cases?.CUSTOMER_ON_ROAD,
      title: incidenceColumnsEnum?.CLIENTE_VÍA_DESTINO,
      status: enumStatus.CUSTOMER_ON_ROAD,
    },
    {
      cases: cases?.SCHEDULED,
      title: incidenceColumnsEnum?.SERVICIOS_AGENDADOS,
      status: enumStatus.SCHEDULED,
    },
    {
      cases: cases?.PENDING_LOAD,
      title: incidenceColumnsEnum?.CARGA_PENDIENTE,
      status: enumStatus.PENDING_LOAD,
    },
    {
      cases: cases?.FOLLOW_UP,
      title: incidenceColumnsEnum?.FOLLOW_UP,
      status: enumStatus.FOLLOW_UP,
    },
    {
      cases: cases?.LOCKSMITH_ACTIVE,
      title: incidenceColumnsEnum?.CERRAJERIA,
      status: enumStatus.LOCKSMITH_ACTIVE,
    },
    {
      cases: cases?.FINISHED,
      title: incidenceColumnsEnum?.SERVICIOS_FINALIZADOS,
      status: enumStatus.FINISHED,
    },
    {
      cases: cases?.FAILED,
      title: incidenceColumnsEnum?.SERVICIOS_FALLIDOS,
      status: enumStatus.FAILED,
    },
  ];
  const buildCaseFilters = (overrides = {}) => {
    let status = sessionStorage.getItem("status");
    let since = sessionStorage.getItem("sinceDate");
    let until = sessionStorage.getItem("untilDate");
    since = since ? since : sinceDate;
    until = until ? until : untilDate;

    let params = {
      sinceDate: since ? moment(since).format("YYYY-MM-DD") : "",
      untilDate: until ? moment(until).format("YYYY-MM-DD") : "",
      status: status ? status : caseStatus,
      caseType: caseTypeFilter,
      search: searchCase,
      ...overrides,
    };

    if (params?.status === enumStatus?.PENDING_PAYMENT) {
      delete params?.status;
      delete params?.caseTypeFilter;
      params.onlyPendingPayment = true;
    }

    // if (operationsRoles?.operationsOperator === user?.roles[0]?.code) {
    // delete params?.sinceDate;
    // delete params?.untilDate;
    // }

    return filterParams(params);
  };

  const getCasesByOperator = (overrides) => {
    let user = sessionStorage.getItem("user");
    user = JSON.parse(user);

    return caseService
      .getCasesByOperator(user?._id, buildCaseFilters(overrides))
      .then((response) => {
        if (response.status === 200) {
          setCaseList(response?.data?.cases || []);
          setIsLoading(false);
          return response;
        } else {
          notify(`${response.message}`, "error");
          setIsLoading(false);
          return response;
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  // Suscribe la vista al socket con los filtros actuales. Si el socket aún no está
  // conectado, se piden los casos por HTTP y la suscripción se envía al conectar.
  const refreshCases = (overrides) => {
    if (!subscribeCases(buildCaseFilters(overrides))) {
      getCasesByOperator(overrides);
    }
  };

  const handleSinceDateChange = (e) => {
    if (e > untilDate && untilDate) {
      notify("Ingrese una fecha en un rago valido ", "info");
    } else {
      setSinceDate(e);
      sessionStorage.setItem(`sinceDate`, e);
    }
  };
  const handleUntilDateChange = (e) => {
    if (e < sinceDate && sinceDate) {
      notify("Ingrese una fecha en un rago valido ", "info");
    } else {
      setUntilDate(e);
      sessionStorage.setItem(`untilDate`, e);
    }
  };

  const getAllDevices = (showOrOptions) => {
    if (validateIfUseRequest()) {
      return;
    }

    if (devicesLocationRequestRef.current) {
      return;
    }

    const silent = Boolean(
      showOrOptions &&
        typeof showOrOptions === "object" &&
        showOrOptions.silent
    );
    const show = showOrOptions === true;

    devicesLocationRequestRef.current = true;

    if (!silent) {
      setDevicesLocation((prevState) => {
        return {
          ...prevState,
          isLoading: true,
        };
      });
    }

    gpsService
      .getAllDevices()
      .then((response) => {
        if (response.status === 200) {
          setDevicesLocation((prevState) => {
            const prevByKey = {};
            (prevState.data || []).forEach((d) => {
              const key = d?.id ?? d?.name;
              if (key != null) prevByKey[key] = d;
            });

            const data = [];
            for (let i = 0; i < response?.data?.length; i++) {
              if (response?.data[i]?.online === "online") {
                const device = response.data[i];
                const key = device?.id ?? device?.name;
                data.push({
                  ...device,
                  show: silent ? Boolean(prevByKey[key]?.show) : show,
                });
              }
            }

            return {
              ...prevState,
              isLoading: false,
              data,
              middlePoint: prevState?.middlePoint
                ? prevState.middlePoint
                : calculateMiddlePoint(data),
            };
          });
        } else {
          if (!silent) {
            notify(`${response.message}`, "error");
          }
          setDevicesLocation((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch(() => {
        setDevicesLocation((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      })
      .finally(() => {
        devicesLocationRequestRef.current = false;
      });
  };

  const showInfoWindow = (index) => {
    let data = [...devicesLocation?.data];
    data[index].show = !data[index].show;
    setDevicesLocation((prevState) => {
      return {
        ...prevState,
        data: data,
      };
    });
  };

  const showLegend = () => {
    let data = [...devicesLocation?.data];
    let isOpen = data?.filter((d) => d?.show);
    for (let i = 0; i < data?.length; i++) {
      if (isOpen?.length > 0) {
        data[i].show = false;
      } else {
        data[i].show = true;
      }
    }
    setDevicesLocation((prevState) => {
      return {
        ...prevState,
        data: data,
      };
    });
  };

  const sameMoney = (left, right) => round2(left) === round2(right);

  const paymentOtpSnapshot = (price, amountHandling, amountExcess) => ({
    price: round2(price),
    amountHandling: round2(amountHandling),
    amountExcess: round2(amountExcess),
  });

  const samePaymentOtp = (left, right) =>
    !!left &&
    !!right &&
    left.price === right.price &&
    left.amountHandling === right.amountHandling &&
    left.amountExcess === right.amountExcess;

  const evaluatePaymentOtp = (overrides = {}, { resetCode = true } = {}) => {
    const price =
      overrides.price !== undefined ? overrides.price : watch2("price");
    const amountHandling =
      overrides.amountHandling !== undefined
        ? overrides.amountHandling
        : watch2("amountHandling");
    const amountExcess =
      overrides.amountExcess !== undefined
        ? overrides.amountExcess
        : watch2("amountExcess");
    const baseline = paymentOtpBaselineRef.current;

    const needsOtp =
      !sameMoney(price, baseline.price) ||
      !sameMoney(amountHandling, baseline.amountHandling) ||
      !sameMoney(amountExcess, baseline.amountExcess);
    const current = paymentOtpSnapshot(price, amountHandling, amountExcess);

    if (!needsOtp) {
      validatedPaymentOtpRef.current = null;
      setValue2("code", "");
      setValue2("approvedBy", "");
      updateOtpStatus(0);
      return;
    }

    if (samePaymentOtp(validatedPaymentOtpRef.current, current)) {
      updateOtpStatus(2);
      return;
    }

    if (resetCode) {
      setValue2("code", "");
      setValue2("approvedBy", "");
    }
    updateOtpStatus(1);
  };

  const handlePriceChange = (event) => {
    const raw = event?.target?.value ?? watch2("price");
    const parsed = parseFloat(String(raw ?? "").replace(/[^\d.]/g, ""));
    const price = Number.isNaN(parsed) ? 0 : parsed;
    getAmountExcess(paymentModal?.incidence, price);
    evaluatePaymentOtp({ price });
  };

  const requestOTP = () => {
    if (!isLoading) {
      setIsLoading(true);
      let towService = paymentModal?.selected;
      const incidence = paymentModal?.incidence;
      const readEntityId = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value;
        const id = value._id || value.id;
        if (typeof id === "string") return id;
        if (id && typeof id === "object") return id._id || id.id || "";
        return "";
      };
      const providerId =
        readEntityId(towService?.provider) ||
        readEntityId(towService?.providerId) ||
        readEntityId(incidence?.lastService?.provider) ||
        readEntityId(
          incidence?.services?.find((service) => service?._id === towService?._id)
            ?.provider
        );
      const params = {
        price: toNumber(watch2("price")),
        amountExcess: toNumber(watch2("amountExcess")),
        amountHandling: toNumber(watch2("amountHandling")),
      };
      if (providerId) params.provider = providerId;
      servicesService
        .requestOTP(towService?._id, params)
        .then((response) => {
          if (response.status === 200) {
            notify("Codigo generado con exito y enviado a su correo", "info");
            setIsLoading(false);
          } else {
            notify(`${response.message}` || "error", "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const validateOTP = () => {
    if (!String(watch2("approvedBy") || "").trim()) {
      setError2("approvedBy", { type: "custom", message: "Obligatorio" });
      notify("Seleccione quien aprueba antes de validar el codigo", "info");
      return;
    }
    setError2("approvedBy", { type: "custom", message: "" });

    const data = {
      code: watch2("code"),
      price: toNumber(watch2("price")),
      amountExcess: toNumber(watch2("amountExcess")),
      amountHandling: toNumber(watch2("amountHandling")),
    };

    if (!isLoading) {
      setIsLoading(true);
      let towService = paymentModal?.selected;
      servicesService
        .validateOTP(towService?._id, data)
        .then((response) => {
          if (response.status === 200) {
            notify("Codigo validado con exito ", "info");
            setIsLoading(false);
            validatedPaymentOtpRef.current = paymentOtpSnapshot(
              data.price,
              data.amountHandling,
              data.amountExcess
            );
            updateOtpStatus(2);
          } else {
            notify(`${response.message}` || "error", "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const handleLocationModal = () => {
    setShowLocationModal((prev) => !prev);
  };

  const handleCashbackMethodsQuantity = () => {
    for (let i = 1; i <= 3; i++) {
      setValue2(`returnedMethod${i}`, "");
      setValue2(`returnedAmount${i}`, "");
      setValue2(`returnedAmountBsS${i}`, "");
      setCashBackImage((prevState) => {
        return {
          ...prevState,
          [`image${i}`]: "",
        };
      });
    }

    if (watch2("cashbackMethodsQuantity") === "1") {
      setValue2(`returnedAmount1`, watch2("amountReturned"));
      setValue2(
        `returnedAmountBsS1`,
        (parseFloat(watch2("amountReturned")) * dollarRate)?.toFixed(2)
      );
    }
  };

  const handleCashbackBs = (index) => {
    let cashbackMethodsQuantity = parseFloat(watch2("cashbackMethodsQuantity"));
    let amountReturned = parseFloat(watch2(`amountReturned`));

    setValue2(
      `returnedAmountBsS${index}`,
      (parseFloat(watch2(`returnedAmount${index}`)) * dollarRate)?.toFixed(2)
    );

    // Automatically set the amount for the last method
    if (index === cashbackMethodsQuantity - 1) {
      let paid = 0;
      for (let i = 1; i < cashbackMethodsQuantity; i++) {
        paid = paid + parseFloat(watch2(`returnedAmount${i}`));
      }

      if (amountReturned - paid <= 0) {
        notify(
          "El la suma de los montos no puede superar el vuelto a entregar",
          "error"
        );
        for (let j = 1; j <= cashbackMethodsQuantity; j++) {
          setValue2(`returnedAmount${j}`, 0);
          setValue2(`returnedAmountBsS${j}`, 0);
        }
        return null;
      }

      setValue2(
        `returnedAmount${cashbackMethodsQuantity}`,
        (amountReturned - paid)?.toFixed(2)
      );
      setValue2(
        `returnedAmountBsS${cashbackMethodsQuantity}`,
        (
          parseFloat(watch2(`returnedAmount${cashbackMethodsQuantity}`)) *
          dollarRate
        )?.toFixed(2)
      );
    }
  };

  const handleDrop = (event, index) => {
    let file = "";
    // File added on drop
    if (event?.dataTransfer?.files) {
      file = Array?.from(event?.dataTransfer?.files)[0];
    }

    let maxWeight = 5; //Peso en MB

    // File added on Click
    if (event?.target?.files?.length > 0) {
      file = event?.target?.files[0];
    }

    if (
      !["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
        file.type
      )
    ) {
      notify("Agregar un formato valido de imagen", "error");
      return null;
    }
    if (file.size * 0.000001 > maxWeight) {
      notify(`La imagen no debe superar los ${maxWeight} MB`, "error");
    }
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: file,
      };
    });
  };

  const removeFile = (index) => {
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: "",
      };
    });
  };

  const validateTotalPayment = (data) => {
    let totalPayment = 0;
    let totalSum =
      parseFloat(watch2("pvp")) +
      parseFloat(watch2("amountHandling")) +
      parseFloat(watch2("amountExcess")) +
      parseFloat(watch2("ivaAmount") || 0)
      ;

    // Load payment methods and amounts if payment status is not N_A  or CUENTA_POR_COBRAR
    if (
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch2("paymentStatus")
      ) ||
      ([PaymentStatus?.CUENTA_POR_COBRAR]?.includes(watch2("paymentStatus")) &&
        watch2("amount0"))
    ) {
      for (var i = 0; i < parseFloat(watch2("paymentMethods")); i++) {
        totalPayment = totalPayment + parseFloat(watch2(`amount${i}`));
      }
    }

    watch2("paymentDifference");

    if (
      watch2("paymentStatus") === PaymentStatus?.CUENTA_POR_COBRAR &&
      watch2("paymentMethods") >= 1 &&
      !watch2("paid")
    ) {
      if (totalSum && totalSum !== totalPayment) {
        notify(sumErrorMessage, "info");
        return false;
      }
      return true;
    }

    // Para realizar ajustes en cuentas por cobrar
    if (
      watch2("paymentStatus") === PaymentStatus?.CUENTA_POR_COBRAR &&
      watch2("paymentMethods") >= 1 &&
      watch2("paid")
    ) {
      if (
        watch2("paymentDifference") &&
        watch2("paymentDifference") !== totalPayment
      ) {
        notify(sumErrorMessage, "info");
        return false;
      }
      return true;
    }

    // Para realizar pagos
    if (
      watch2("paymentDifference") &&
      watch2("paymentDifference") !== totalPayment &&
      watch2("paymentStatus") !== PaymentStatus?.CUENTA_POR_COBRAR
    ) {
      notify(sumErrorMessage + '6', "info");
      return false;
    } else return true;
  };

  const calculateCashBack = () => {
    if (parseFloat(watch2("paid")) > parseFloat(watch2("amount0"))) {
      setValue2(
        "paidBsS",
        (parseFloat(watch2("paid")) * dollarRate)?.toFixed(2)
      );

      if (!watch2("cashbackMethodsQuantity")) {
        setValue2("cashbackMethodsQuantity", 1);
        let amountReturned =
          parseFloat(watch2(`amount0`)) - parseFloat(watch2("paid"));
        if (parseFloat(watch2(`amount1IGTF`))) {
          amountReturned = amountReturned + parseFloat(watch2(`amount1IGTF`));
        }
        amountReturned = amountReturned?.toFixed(2);
        setValue2("amountReturned", Math.abs(amountReturned));
        setValue2(
          "amountReturnedBsS",
          (parseFloat(watch2("amountReturned")) * dollarRate)?.toFixed(2)
        );
        setValue2(`returnedAmount1`, Math.abs(amountReturned));
        setValue2(
          `returnedAmountBsS1`,
          (parseFloat(watch2("amountReturned")) * dollarRate)?.toFixed(2)
        );
      }
    }
  };

  const editPayment = handleSubmit6(async (data) => {
    if (!validateUpdatePaymentRefLenght(data, setError6, paymentMethods))
      return;

    if (!paymentDate) {
      notify("Fecha de pago es obligatoria", "error");
      return null;
    }

    const formData = new FormData();
    formData.append("service", editPaymentModal?.selected?.service);
    formData.append("payment[id]", editPaymentModal?.selected?._id);
    formData.append("payment[amount]", data?.amount);
    formData.append("payment[amountBsS]", data?.amountBsS);
    formData.append("payment[date]", paymentDate);
    formData.append("payment[method]", data?.method);
    formData.append("payment[reference]", data?.reference);

    if (
      [
        metodosDePago?.CASH_USD,
        metodosDePago?.CASH_BS,
        metodosDePago?.CASH_EUR,
      ].includes(filterOptionById(paymentMethods, data?.method)?.name)
    ) {
      formData.append(`payment[cashReceiver]`, data?.cashReceiver);
    }

    if (isZelleOrPaypal(paymentMethods, watch6("method"))) {
      formData.append("payment[accHolder]", data?.reference);
    }

    if (!isLoading) {
      setIsLoading(true);
      paymentService
        .editService(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Pago actualizado`, "success");
            getCasesByOperator();
            handleEditPayment();
            setIsLoading(false);
          } else {
            notify(`${response.message} `, "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const handleEditPayment = (data) => {
    if (data) {
      handlePaymentModal();
      setValue6("amount", data?.totalAmount);
      setValue6("amountBsS", data?.totalAmountInBsS);
      setValue6("method", data?.method[0]?._id);
      setValue6("reference", data?.reference);
      setPaymentDate(new Date(data?.createdAt));
    }

    setEditPaymentModal({
      isOpen: data ? true : false,
      selected: data ? data : "",
    });
  };

  const validateCashBackTotal = () => {
    let cashbackMethodsQuantity = parseFloat(watch2("cashbackMethodsQuantity"));
    let amountReturned = parseFloat(watch2(`amountReturned`));
    let total = 0;
    for (let i = 1; i <= cashbackMethodsQuantity; i++) {
      total = total + parseFloat(watch2(`returnedAmount${i}`));
    }

    if (total !== amountReturned) {
      notify(
        "El la suma de los montos debe ser igual al monto a entregar",
        "error"
      );
      return false;
    }
    if (!watch2("returnedMethod1")) {
      // setError2(`returnedMethod1`, { type: 'custom', message: 'Obligatorio' });
      return false;
    } else {
      return true;
    }
  };

  const validateCashBackImages = () => {
    let cashbackMethodsQuantity = parseFloat(watch2("cashbackMethodsQuantity"));
    let canPost = true;

    setErrorsDropzone((prevState) => {
      return {
        ...prevState,
        error1: false,
        error2: false,
        error3: false,
      };
    });

    for (let i = 1; i <= cashbackMethodsQuantity; i++) {
      const requiredMetods = paymentMethods?.filter((method) =>
        [
          metodosDePago?.CASH_BS,
          metodosDePago?.CASH_EUR,
          metodosDePago?.CASH_USD,
          metodosDePago?.PUNTO_DE_VENTA,
        ]?.includes(method?.name)
      );
      const method = filterOptionById(
        requiredMetods,
        watch2("returnedMethod" + i)
      );

      if (method && !watch2(`returnedReference${i}`)) {
        setError2(`returnedReference${i}`, {
          type: "custom",
          message: "Obligatorio",
        });
        canPost = false;
      }

      if (!cashBackImage[`image${i}`] && method) {
        notify(
          `Adjunte todos los comprobantes de pago de ${method?.name}`,
          "error"
        );
        canPost = false;
        setErrorsDropzone((prevState) => {
          return {
            ...prevState,
            [`error${i}`]: true,
          };
        });
      }
    }
    return canPost;
  };

  const getAvailableVehicles = () => {
    vehicularAssetsService
      .getAvailableVehicles()
      .then((response) => {
        let data = [];

        data = response?.data?.map((a) => ({
          name: capitalize(a?.alias) + " " + (a?.plate).toUpperCase(),
          _id: a?._id,
          class: a?.class,
        }));
        if (response.status === 200) {
          if (
            [operationsRoles?.OPERATIONS_FLOTA_AV]?.includes(
              authService.getUserType()
            )
          ) {
            data = data?.filter((a) => {
              return a.class === "MOTO";
            });
          }
          if (
            [operationsRoles?.OPERATIONS_FLOTA_GRUA]?.includes(
              authService.getUserType()
            )
          ) {
            data = data?.filter((a) => {
              return a.class === "GRÚA";
            });
          }

          setVehicleList(data);
          setTimeout(() => {
            let assignedVehicle =
              authService?.getAssignedVehicle("assignedVehicle");
            getVehicleById(assignedVehicle?._id);
            if (assignedVehicle?.brand) {
              setValue(
                "vehicle",
                capitalize(assignedVehicle?.brand) +
                " " +
                capitalize(assignedVehicle?.model) +
                " " +
                capitalize(assignedVehicle?.color) +
                " " +
                assignedVehicle?.plate +
                " " +
                assignedVehicle?.year
              );
            }

            if (assignedVehicle?.name) {
              setValue("vehicle", capitalize(assignedVehicle?.name));
            }
          }, 1500);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
    return true;
  };

  const getAdminSupervisors = () => {
    if (validateIfUseRequest()) {
      return;
    }

    usersService
      .getAdminSupervisors()
      .then((response) => {
        if (response.status === 200) {
          let data = [];

          for (let i = 0; i < response?.data?.users.length; i++) {
            data.push({
              _id: response?.data?.users[i]?.fullName,
              name: response?.data?.users[i]?.fullName,
            });
          }
          setSupervisors(data);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const getAmountExcess = (incidence, cost) => {
    const requestId = ++excessRequestRef.current;
    const params = {
      caseId: incidence?._id,
      cost: cost || watch2("price"),
    };

    caseService
      .calculateExcess(params)
      .then((response) => {
        if (requestId !== excessRequestRef.current) return;

        const calculated =
          response.status === 200 ? toNumber(response?.data?.excess) : 0;
        if (response.status !== 200) {
          notify(`${response.message}`, "error");
        }

        const previousExcess = toNumber(watch2("amountExcess"));
        setValue2(
          "amountExcess",
          response.status === 200 ? calculated.toFixed(2) : 0
        );
        paymentOtpBaselineRef.current.amountExcess = calculated;
        evaluatePaymentOtp(
          { amountExcess: calculated, price: params.cost },
          { resetCode: !sameMoney(previousExcess, calculated) }
        );
      })
      .catch(() => {});
  };

  const getVehicleById = async (vehicleId) => {
    if (!vehicleId) return;
    vehicularAssetsService
      .getVehicleById(vehicleId)
      .then((response) => {
        if (response.status === 200) {
          setVehicleDocuments((prevState) => {
            return {
              ...prevState,
              rcv: response?.data?.vehicularAsset?.rcv,
              propertyTitle: response?.data?.vehicularAsset?.propertyTitle,
            };
          });
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const handleSearchCase = (e) => {
    if (!e.target.value) {
      refreshCases({ search: "" });
    }
    setSearchCase(e.target.value);
  };

  const reloadCases = () => {
    getCasesByOperator();
  };

  const getCashReceivers = () => {
    cashReceiverService
      .getCashReceivers()
      .then((response) => {
        if (response.status === 200) {
          setCashReceiverOptions(response?.data?.cashReceivers);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((e) => {
        console.log("Error trayendo las cajas de efectivo", e);
      });
  };

  useEffect(() => {
    getAllDevices(); //Not for operators
    getAdminSupervisors(); //Not for operators
    getFaults();
    getContactChannel(); //Not for operators
    getUsers(); //Not for operators
    getDollarRate(); //Not for operators
    getPaymentMethods(); //Not for operators
    getAvailableVehicles();
    getCashReceivers(); //Not for operators
    if (!validateIfUseRequest()) {
      getAVs();
      getInternalTows();
      getExternalTows();
    }
  }, []);

  useEffect(() => {
    refreshCases();
  }, [caseStatus, caseTypeFilter, sinceDate, untilDate, location.key]);

  //* Detectar si es mobile o desktop */
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { handleAddIva } = useIvaCalculation({
    watch: watch2,
    setValue: setValue2,
    afterChange: restorePaymentMethods,
  });

  return (
    <>
      <LoadSpinner show={isLoading} />
      <AllDevicesMapModal
        modal={{ show: showLocationModal, devicesLocation: devicesLocation }}
        handleModal={handleLocationModal}
        refresh={getAllDevices}
        showInfoWindow={showInfoWindow}
        showLegend={showLegend}
      />
      {hideForOperators() && (
        <CraneCounter
          showCraneCounterModal={showCraneCounterModal}
          openDocumentModal={openDocumentModal}
          zoomDocumentModal={zoomDocumentModal}
        />
      )}
      <Header />
      <SelectServicePaymentModal
        modal={selectServicePayment}
        handleClose={handleSelectService}
        handlePaymentModal={handlePaymentModal}
      />

      <SelectCashbackPaymentModal
        modal={selectCashbackPayment}
        handleClose={handleUpdateCashback}
        handleCashbackModal={handleCashbackModal}
      />
      <CreatePaymentModal
        modal={paymentModal}
        register={register2}
        errors={errors2}
        watch={watch2}
        control={control2}
        fileUploaded={fileUploaded}
        setFileUploaded={setFileUploaded}
        action={createPayment}
        handleEditPayment={handleEditPayment}
        cancel={handlePaymentModal}
        options={{
          paymentMethods: paymentMethods,
          PaymentStatusOptions: paymentStatusOptions,
          authorizedByOptions: supervisors,
          filteredMethods: filteredMethods,
          cashReceiverOptions,
        }}
        onChange={{
          setBsRate: setBsRate,
          restorePaymentMethods: restorePaymentMethods,
          changePaymentStatus: changePaymentStatus,
          validateMaxPaymentMethods: validateMaxPaymentMethods,
          handleCashbackMethodsQuantity: handleCashbackMethodsQuantity,
          handleCashbackBs: handleCashbackBs,
          handlePriceChange: handlePriceChange,
          evaluatePaymentOtp: evaluatePaymentOtp,
          setIsloading: setIsLoading,
          handleAddIva: handleAddIva,
          getDollarRateByPaymentDate: getDollarRateByPaymentDate,
        }}
        handleDrop={handleDrop}
        cashBackImage={cashBackImage}
        removeFile={removeFile}
        errorsDropzone={errorsDropzone}
        OTP={{
          requestOTP: requestOTP,
          validateOTP: validateOTP,
          optStatus: optStatus,
        }}
        setValue={setValue2}
        showErrorAPI={showErrorAPI}
      />

      <EditPaymentModal
        modal={editPaymentModal}
        register={register6}
        errors={errors6}
        watch={watch6}
        control={control6}
        fileUploaded={fileUploaded}
        setFileUploaded={setFileUploaded}
        action={editPayment}
        paymentDate={paymentDate}
        cancel={handleEditPayment}
        options={{
          paymentMethods: paymentMethods,
          cashReceiverOptions,
        }}
        onChange={{
          getDollarRateByDate: getDollarRateByDate,
        }}
      />

      <EditCashbackModal
        modal={cashbackModal}
        register={register4}
        errors={errors4}
        watch={watch4}
        control={control4}
        fileUploaded={cashBackImage}
        setFileUploaded={setFileUploaded}
        action={editCashback}
        cancel={handleCashbackModal}
        options={{
          paymentMethods: paymentMethods,
        }}
        onChange={{
          setBsRate: setBsRate,
          restorePaymentMethods: restorePaymentMethods,
          changePaymentStatus: changePaymentStatus,
          validateMaxPaymentMethods: validateMaxPaymentMethods,
          handleCashbackMethodsQuantity: handleCashbackMethodsQuantity,
          handleCashbackBs: handleCashbackBs,
        }}
        handleDrop={handleDrop}
        cashBackImage={cashBackImage}
        removeFile={removeFile}
        errorsDropzone={errorsDropzone}
      />

      {showSMSModal?._case?.lastService?.product?.code === afiliatedServices?.LOCKSMITH ? (
        <MessageLocksmithModal
          showSMSModal={showSMSModal}
          handleClose={openSMSModal}
          caseInfo={showSMSModal?._case}
          service={showSMSModal?._case?.lastService?.product}
          _case={showSMSModal?._case}
        />
      ) : (
        <MessageAVModal
          showSMSModal={showSMSModal}
          handleClose={openSMSModal}
          caseInfo={showSMSModal?._case}
        // service={showSMSModal?._case?.lastService?.}
        />
      )}
      <MessageTowModal
        showSMSModal={showSMSTowModal}
        handleClose={openSMSTowModal}
        caseInfo={showSMSTowModal?._case}
      // service={openSMSTowModal?._case?.lastService?.}
      />
      <MessageTaxiModal
        showSMSModal={showTaxiSMSModal}
        handleClose={openTaxiSMSModal}
        caseInfo={showTaxiSMSModal?._case}
      />
      <ChangeCaseStageModal
        showChangeStatusModal={showChangeStatusModal}
        handleClose={handleChangeStatusModal}
        updateCaseStage={updateCaseStage}
      />

      <CancelServiceModal
        modal={showCancelService}
        handleClose={() => handleCancelService()}
        refresh={getCasesByOperator}
        cancelService={handleCancelSingleService}
      />
      <CancelSingleServiceModal
        modal={showCancelSingleService}
        handleClose={() => handleCancelSingleService()}
        refresh={getCasesByOperator}
      />
      <CancelCaseModal
        showCancelCase={showCancelCase}
        handleClose={() => handleCancelCase()}
        refresh={getCasesByOperator}
      />
      <RollbackStageModal
        modal={showRollbackStage}
        handleClose={() => handleRollbackCase()}
        refresh={getCasesByOperator}
      />
      <ScheduleServicesModal
        show={showScheduleRescheduleModal.show}
        handleClose={() => closeScheduleRescheduleModal(false)}
        register={register7}
        control={control7}
        errors={errors7}
        action={rescheduleScheduledService}
        t={t}
      />
      <ScheduleServicesModal
        show={showToggleScheduleModal.show}
        handleClose={() => closeToggleScheduleModal(false)}
        register={register9}
        control={control9}
        errors={errors9}
        action={submitToggleToScheduled}
        t={t}
      />
      <ScheduleTowModal
        show={showScheduleTowModal.show}
        handleClose={() => closeScheduleTowModal(false)}
        register={register10}
        control={control10}
        errors={errors10}
        action={submitScheduleTow}
        t={t}
      />
      <FailedCaseModal
        showCancelCase={showFailedCase}
        handleClose={() => handleFailedCase()}
        refresh={getCasesByOperator}
      />
      <UploadImageModal
        imageModal={showImageModal}
        handleClose={handleLoadImageModal}
      />
      <ServiceImageModal
        imageModal={showServiceImageModal}
        handleClose={handleServiceImageModal}
      />
      <LocksmithReimbursementModal
        modal={showReembolsoModal}
        handleClose={handleReembolsoModal}
        refresh={getCasesByOperator}
        dollarRate={dollarRate}
      />
      <LocksmithFinishModal
        modal={locksmithFinishModal}
        handleClose={closeLocksmithFinishModal}
        refresh={getCasesByOperator}
      />
      <FinishCaseModal
        finishCaseModal={showFinishCaseModal}
        handleClose={handleFinishCaseModal}
        options={faultOptions}
        refresh={getCasesByOperator}
      />
      <SolvedByAVModal
        solvedByAVModal={showSolvedByAVModal}
        handleClose={handleSolvedByAVModal}
        options={faultOptions}
        refresh={getCasesByOperator}
      />
      <FinishTowCaseModal
        solvedByAVModal={showFinishTowCaseModal}
        handleClose={handleFinishTowCaseModal}
        options={faultOptions}
        refresh={getCasesByOperator}
      />
      <FailureAssignTowModal
        solvedByAVModal={showFailureAssignModal}
        handleClose={handleFailureAssignModal}
        options={faultOptions}
        refresh={getCasesByOperator}
        createTowService={createTowService}
      />
      <ChangeOperatorModal
        showChangeOperatorModal={showChangeOperatorModal}
        handleClose={handleChangeOperatorModal}
        options={operatorsOptions}
        refresh={getCasesByOperator}
      />
      <RegisterFollowUPModal
        modal={showFollowUpModal}
        handleClose={handleFollowUpModal}
        options={{
          operatorsOptions: operatorsOptions,
          contactChannelOptions: contactChannelOptions,
        }}
        refresh={getCasesByOperator}
        register={register3}
        errors={errors3}
        watch={watch3}
        control={control3}
        action={registerFollowUp}
      />
      <ChangeProviderModal
        changeProviderModal={changeProviderModal}
        handleClose={handleChangeProviderModal}
        options={providersOptions}
        refresh={getCasesByOperator}
        value={selectedProvider}
        onChange={handleSelectedProviderModal}
        action={updateProvider}
      />
      <TaxiServiceModal
        modal={taxiServiceModal}
        handleClose={handleTaxiServiceModal}
        register={register8}
        errors={errors8}
        watch={watch8}
        requestTaxiOtp={requestTaxiOtp}
        validateTaxiCode={validateTaxiCode}
        otpCooldown={taxiOtpCooldown}
      />
      <ChangeTowModal
        register={register5}
        errors={errors5}
        watch={watch5}
        changeProviderModal={changeTowModal}
        handleClose={handleChangeTowModal}
        options={{
          userTypeOptions: userTypeOptions,
          towOptions: towOptions,
          externalTowOptions: externalTowOptions,
          authorizedByOptions: supervisors,
        }}
        refresh={getCasesByOperator}
        value={selectedTow}
        handleTowType={handleTowType}
        towType={towType}
        onChange={{
          handleTowType: handleTowType,
          handleTow: handleTow,
          requestTowOTP: requestTowOTP,
          validateTowOTP: validateTowOTP,
        }}
        action={updateTow}
      />
      <NewIncidenceModal
        show={showIncidenceModal}
        handleClose={setShowIncidenceModal}
        particular={() => history.push("/incidence/create/particular")}
        afiliated={() => history.push("/incidence/create-affiliated")}
        alliance={() => history.push("/incidence/create/alliance")}
      />
      <FollowingModal
        showFollowingModal={showFollowingModal}
        handleClose={handleFollowingCaseModal}
        refresh={getCasesByOperator}
      />
      <div style={{ width: "100%", justifyItems: "flex-end" }}>
        <div className="buttons-container">
          {vehicleDocuments?.rcv && (
            <a target="_blank" href={vehicleDocuments?.rcv} rel="noreferrer">
              <ActionButton label={"RCV"} />
            </a>
          )}

          {vehicleDocuments?.propertyTitle && (
            <a
              target="_blank"
              href={vehicleDocuments?.propertyTitle}
              rel="noreferrer"
            >
              <ActionButton label={"Titulo del Vehiculo"} />
            </a>
          )}
        </div>
      </div>

      {[
        operationsRoles.OPERATIONS_FLOTA_AV,
        operationsRoles.OPERATIONS_FLOTA_GRUA,
      ].includes(authService.getUserType()) && (
          <div>
            <h5 style={{ textAlign: "center" }}>
              Proveedor{" "}
              {authService?.getUser()?.provider?.isActive ? "Activo" : "Inactivo"}
            </h5>
            <div className="activate-unit-form">
              <form style={{ width: "300px" }} className="form-container">
                <div className="row">
                  {!authService?.getAssignedVehicle() && (
                    <Input
                      bootstrap={"col-12"}
                      label={"Unidad Seleccionada*"}
                      type={"select"}
                      options={vehicleList}
                      name={"vehicle"}
                      register={register}
                      placeholder={""}
                      errors={errors?.vehicle?.message}
                      capitalizeOff={true}
                    />
                  )}
                  {authService?.getAssignedVehicle() && (
                    <Input
                      bootstrap={"col-12"}
                      label={"Unidad Seleccionada*"}
                      type={"text"}
                      options={vehicleList}
                      name={"vehicle"}
                      register={register}
                      placeholder={""}
                      errors={errors?.vehicle?.message}
                      disabled={true}
                      capitalizeOff={true}
                    />
                  )}
                </div>
              </form>
            </div>
            <div className="buttons-center-container">
              <ActivateButtons action={activateProvider} />
              {[
                operationsRoles.OPERATIONS_FLOTA_GRUA,
                operationsRoles.OPERATIONS_FLOTA_GRUA_EXT,
                operationsRoles.OPERATIONS_FLOTA_AV,
              ].includes(authService.getUserType()) && (
                  <ActionButton label={"Actualizar Casos"} action={reloadCases} />
                )}
            </div>
          </div>
        )}
      <div className="service-with-container container">
        <h1 style={{ marginBottom: "0px" }} className="title-component">
          Servicios
        </h1>
        <div className="service-filter-button-container">
          {hideForOperators() &&
            ![operationsRoles.operationsOperator].includes(
              authService.getUserType()
            ) ? (
            <div className="filter-button-area">
              {filterButtons.map((f) => (
                <FilterButton
                  key={f.name}
                  button={f}
                  selected={caseTypeFilter}
                  selectButton={selectButton}
                />
              ))}
            </div>
          ) : (
            <span></span>
          )}
          {hideForOperators() && (
            <div className="service-date-filters">
              <FilterDatePicker
                bootstrap={""}
                label={"Desde"}
                type={"date"}
                name={"untilDate"}
                placeholder={""}
                onChange={handleSinceDateChange}
                value={sinceDate}
              />
              <FilterDatePicker
                bootstrap={""}
                label={"Hasta"}
                type={"date"}
                name={"untilDate"}
                placeholder={""}
                onChange={handleUntilDateChange}
                value={untilDate}
              />
            </div>
          )}
        </div>
        <div className="gray-line"></div>
        <br />
        <div className="buttons-container">
          {hideForOperators() && (
            <ActionButton
              action={() => setShowIncidenceModal(true)}
              label={"+ Nueva Incidencia"}
            />
          )}
          <div className="service-filter-buttons-container">
            {![
              operationsRoles?.OPERATIONS_FLOTA_AV,
              operationsRoles?.OPERATIONS_FLOTA_GRUA,
              operationsRoles?.OPERATIONS_FLOTA_GRUA_EXT,
            ].includes(authService.getUserType()) && (
                <AltButton
                  label="Ubicación de Choferes"
                  action={() => handleLocationModal(true)}
                />
              )}
            {hideForOperators() && (
              <FilterCaseButton
                label="Cuentas por Cobrar"
                value={enumStatus.PENDING_PAYMENT}
                caseStatus={caseStatus}
                action={selectStatusFilter}
              />
            )}
            {/* {hideForOperators() &&
              <FilterCaseButton
                label="Servicios agendados"
                value={enumStatus.SCHEDULED}
                caseStatus={caseStatus}
                action={selectStatusFilter}
              />
            } */}
            {hideForOperators() && (
              <FilterCaseButton
                label="Finalizados"
                value={enumStatus.FINISHED}
                caseStatus={caseStatus}
                action={selectStatusFilter}
              />
            )}
            {hideForOperators() && (
              <SearchInput
                value={searchCase}
                onChange={handleSearchCase}
                searchAction={() => refreshCases()}
                placeholder={"Codigo, Nombre o Apellido, Cédula o Placa"}
              />
            )}
          </div>
        </div>

        {!hideForOperators() && isMobile ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {casesByOperator.map((c) => (
              <IncidenceCards
                key={c?._id}
                _case={c}
                options={options}
                actionButtons={actionButtons}
                statusButtons={statusButtons}
                handleSMSModal={handleSMSModal}
                handleSelectService={handleSelectService}
                actions={{ asignCrane: asignCrane }}
                changeStatusForAV={handleChangeStatusModal}
                handleImageModalForOperator={handleServiceImageModal}
                handleReembolsoModal={handleReembolsoModal}
              />
            ))}
          </div>
        ) : (
          <div className="service-incidence-wrapper">
            <div className="top-scroll" ref={topScrollRef}>
              <div className="top-scroll-inner" />
            </div>

            <div
              className="service-incidence-overflow-container"
              ref={contentScrollRef}
            >
              <div className="service-incidence-break-container">
                {incidenceColumn?.map((i) => (
                  <IncidenceColumn
                    key={i?.title}
                    cases={i?.cases}
                    options={options}
                    actionButtons={actionButtons}
                    statusButtons={statusButtons}
                    handleSMSModal={handleSMSModal}
                    title={i?.title}
                    status={i?.status}
                    caseStatus={caseStatus}
                    handleSelectService={handleSelectService}
                    actions={{ asignCrane: asignCrane }}
                    handleReembolsoModal={handleReembolsoModal}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
